{
  "about.blocks": "Beperkte en opgeschorte servers",
  "about.contact": "Contact:",
  "about.default_locale": "Standaard",
  "about.disclaimer": "Mastodon is vrije, opensourcesoftware en een handelsmerk van Mastodon gGmbH.",
  "about.domain_blocks.no_reason_available": "Reden niet beschikbaar",
  "about.domain_blocks.preamble": "In het algemeen kun je met Mastodon berichten ontvangen van, en interactie hebben met gebruikers van elke server in de fediverse. Dit zijn de uitzonderingen die op deze specifieke server gelden.",
  "about.domain_blocks.silenced.explanation": "In het algemeen zie je geen berichten en accounts van deze server, tenzij je berichten expliciet opzoekt of ervoor kiest om een account van deze server te volgen.",
  "about.domain_blocks.silenced.title": "Beperkt",
  "about.domain_blocks.suspended.explanation": "Er worden geen gegevens van deze server verwerkt, opgeslagen of uitgewisseld, wat interactie of communicatie met gebruikers van deze server onmogelijk maakt.",
  "about.domain_blocks.suspended.title": "Opgeschort",
  "about.language_label": "Taal",
  "about.not_available": "Deze informatie is niet beschikbaar gemaakt op deze server.",
  "about.powered_by": "Gedecentraliseerde sociale media mogelijk gemaakt door {mastodon}",
  "about.rules": "Serverregels",
  "account.account_note_header": "Persoonlijke opmerking",
  "account.activity": "Activiteit",
  "account.add_note": "Een persoonlijke opmerking toevoegen",
  "account.add_or_remove_from_list": "Toevoegen aan of verwijderen uit lijsten",
  "account.badges.admin": "Beheerder",
  "account.badges.blocked": "Geblokkeerd",
  "account.badges.bot": "Geautomatiseerd",
  "account.badges.domain_blocked": "Geblokkeerd domein",
  "account.badges.group": "Groep",
  "account.badges.muted": "Genegeerd",
  "account.badges.muted_until": "Genegeerd tot {until}",
  "account.block": "@{name} blokkeren",
  "account.block_domain": "Alles van {domain} blokkeren",
  "account.block_short": "Blokkeren",
  "account.blocked": "Geblokkeerd",
  "account.blocking": "Geblokkeerd",
  "account.cancel_follow_request": "Ontvolgen",
  "account.copy": "Link naar profiel kopiëren",
  "account.direct": "@{name} een privébericht sturen",
  "account.disable_notifications": "Geen melding meer geven wanneer @{name} een bericht plaatst",
  "account.domain_blocking": "Server geblokkeerd",
  "account.edit_note": "Persoonlijke opmerking bewerken",
  "account.edit_profile": "Profiel bewerken",
  "account.edit_profile_short": "Bewerken",
  "account.enable_notifications": "Geef een melding wanneer @{name} een bericht plaatst",
  "account.endorse": "Op profiel weergeven",
  "account.familiar_followers_many": "Gevolgd door {name1}, {name2} en {othersCount, plural, one {één ander bekend account} other {# andere bekende accounts}}",
  "account.familiar_followers_one": "Gevolgd door {name1}",
  "account.familiar_followers_two": "Gevolgd door {name1} en {name2}",
  "account.featured": "Uitgelicht",
  "account.featured.accounts": "Profielen",
  "account.featured.collections": "Verzamelingen",
  "account.featured.hashtags": "Hashtags",
  "account.featured_tags.last_status_at": "Laatste bericht op {date}",
  "account.featured_tags.last_status_never": "Geen berichten",
  "account.field_overflow": "Volledige inhoud tonen",
  "account.filters.all": "Alle activiteit",
  "account.filters.boosts_toggle": "Boosts tonen",
  "account.filters.posts_boosts": "Berichten en boosts",
  "account.filters.posts_only": "Berichten",
  "account.filters.posts_replies": "Berichten en reacties",
  "account.filters.replies_toggle": "Reacties tonen",
  "account.follow": "Volgen",
  "account.follow_back": "Terugvolgen",
  "account.follow_back_short": "Terugvolgen",
  "account.follow_request": "Volgverzoek",
  "account.follow_request_cancel": "Verzoek annuleren",
  "account.follow_request_cancel_short": "Annuleren",
  "account.follow_request_short": "Verzoek",
  "account.followers": "Volgers",
  "account.followers.empty": "Deze gebruiker heeft nog geen volgers of heeft deze verborgen.",
  "account.followers_counter": "{count, plural, one {{counter} volger} other {{counter} volgers}}",
  "account.followers_you_know_counter": "{counter} die je kent",
  "account.following": "Volgend",
  "account.following_counter": "{count, plural, one {{counter} volgend} other {{counter} volgend}}",
  "account.follows.empty": "Deze gebruiker volgt nog niemand of heeft deze verborgen.",
  "account.follows_you": "Volgt jou",
  "account.go_to_profile": "Ga naar profiel",
  "account.hide_reblogs": "Boosts van @{name} verbergen",
  "account.in_memoriam": "In memoriam.",
  "account.joined_short": "Geregistreerd",
  "account.languages": "Getoonde talen wijzigen",
  "account.link_verified_on": "Eigendom van deze link is gecontroleerd op {date}",
  "account.locked_info": "De privacystatus van dit account is ingesteld op vergrendeld. De eigenaar beoordeelt handmatig wie diegene kan volgen.",
  "account.media": "Media",
  "account.mention": "@{name} vermelden",
  "account.menu.add_to_list": "Aan lijst toevoegen…",
  "account.menu.block": "Account blokkeren",
  "account.menu.block_domain": "{domain} blokkeren",
  "account.menu.copied": "Accountlink naar het klembord gekopieerd",
  "account.menu.copy": "Link kopiëren",
  "account.menu.direct": "Privébericht",
  "account.menu.hide_reblogs": "Boosts op tijdlijn verbergen",
  "account.menu.mention": "Vermelding",
  "account.menu.mute": "Account negeren",
  "account.menu.note.description": "Alleen voor jou zichtbaar",
  "account.menu.open_original_page": "Op {domain} bekijken",
  "account.menu.remove_follower": "Volger verwijderen",
  "account.menu.report": "Account rapporteren",
  "account.menu.share": "Delen…",
  "account.menu.show_reblogs": "Boosts op tijdlijn tonen",
  "account.menu.unblock": "Account deblokkeren",
  "account.menu.unblock_domain": "{domain} deblokkeren",
  "account.menu.unmute": "Account niet langer negeren",
  "account.moved_to": "{name} is verhuisd naar:",
  "account.mute": "@{name} negeren",
  "account.mute_notifications_short": "Meldingen negeren",
  "account.mute_short": "Negeren",
  "account.muted": "Genegeerd",
  "account.muting": "Genegeerd",
  "account.mutual": "Jullie volgen elkaar",
  "account.name.help.domain": "{domain} is de server waar zich het profiel en de berichten van de gebruiker bevinden.",
  "account.name.help.domain_self": "{domain} is jouw server waar zich jouw profiel en berichten bevinden.",
  "account.name.help.footer": "Net zoals je e-mails kunt verzenden naar mensen met verschillende e-mailproviders, kun je interactie hebben met mensen op andere Mastodon-servers – en met iedereen op andere social apps, die met behulp van het ActivityPub-protocol met Mastodon kunnen communiceren.",
  "account.name.help.header": "Een fediverse-adres valt te vergelijken met een e-mailadres",
  "account.name.help.username": "{username} is de gebruikersnaam van het account op hun server. Het is mogelijk dat iemand anders dezelfde gebruikersnaam op een andere server heeft.",
  "account.name.help.username_self": "{username} is jouw gebruikersnaam op deze server. Het is mogelijk dat iemand anders dezelfde gebruikersnaam op een andere server heeft.",
  "account.name_info": "Wat betekent dit?",
  "account.no_bio": "Geen beschrijving opgegeven.",
  "account.node_modal.callout": "Persoonlijke opmerkingen zijn alleen zichtbaar voor jou.",
  "account.node_modal.edit_title": "Persoonlijke opmerking bewerken",
  "account.node_modal.error_unknown": "Kon opmerking niet opslaan",
  "account.node_modal.field_label": "Persoonlijke opmerking",
  "account.node_modal.save": "Opslaan",
  "account.node_modal.title": "Een persoonlijke opmerking toevoegen",
  "account.note.edit_button": "Bewerken",
  "account.note.title": "Persoonlijke opmerking (alleen zichtbaar voor jou)",
  "account.open_original_page": "Originele pagina openen",
  "account.posts": "Berichten",
  "account.remove_from_followers": "{name} als volger verwijderen",
  "account.report": "@{name} rapporteren",
  "account.requested_follow": "{name} wil jou graag volgen",
  "account.requests_to_follow_you": "Wil jou graag volgen",
  "account.share": "Account van @{name} delen",
  "account.show_reblogs": "Boosts van @{name} tonen",
  "account.statuses_counter": "{count, plural, one {{counter} bericht} other {{counter} berichten}}",
  "account.timeline.pinned": "Vastgezet",
  "account.timeline.pinned.view_all": "Alle vastgezette berichten bekijken",
  "account.unblock": "@{name} deblokkeren",
  "account.unblock_domain": "{domain} niet langer blokkeren",
  "account.unblock_domain_short": "Deblokkeren",
  "account.unblock_short": "Deblokkeren",
  "account.unendorse": "Niet op profiel weergeven",
  "account.unfollow": "Ontvolgen",
  "account.unmute": "@{name} niet langer negeren",
  "account.unmute_notifications_short": "Meldingen niet langer negeren",
  "account.unmute_short": "Niet langer negeren",
  "account_edit.bio.add_label": "Biografie toevoegen",
  "account_edit.bio.edit_label": "Biografie bewerken",
  "account_edit.bio.placeholder": "Vertel iets over jezelf, zodat anderen inzicht krijgen in wat voor persoon je bent.",
  "account_edit.bio.title": "Biografie",
  "account_edit.bio_modal.add_title": "Biografie toevoegen",
  "account_edit.bio_modal.edit_title": "Biografie bewerken",
  "account_edit.column_button": "Klaar",
  "account_edit.column_title": "Profiel bewerken",
  "account_edit.custom_fields.add_label": "Veld toevoegen",
  "account_edit.custom_fields.edit_label": "Veld bewerken",
  "account_edit.custom_fields.placeholder": "Voeg je voornaamwoorden, externe links of iets anders toe dat je wilt delen.",
  "account_edit.custom_fields.reorder_button": "Velden opnieuw ordenen",
  "account_edit.custom_fields.tip_content": "Je kunt gemakkelijk je Mastodon-account geloofwaardig maken door links naar websites die van jou zijn te laten verifiëren.",
  "account_edit.custom_fields.tip_title": "Tip: Geverifieerde links toevoegen",
  "account_edit.custom_fields.title": "Extra velden",
  "account_edit.custom_fields.verified_hint": "Hoe voeg ik een geverifieerde link toe?",
  "account_edit.display_name.add_label": "Weergavenaam toevoegen",
  "account_edit.display_name.edit_label": "Weergavenaam bewerken",
  "account_edit.display_name.placeholder": "Je weergavenaam wordt op jouw profiel en op tijdlijnen weergegeven.",
  "account_edit.display_name.title": "Weergavenaam",
  "account_edit.featured_hashtags.edit_label": "Hashtags toevoegen",
  "account_edit.featured_hashtags.placeholder": "Geef anderen een overzicht van en snel toegang tot je favoriete onderwerpen.",
  "account_edit.featured_hashtags.title": "Uitgelichte hashtags",
  "account_edit.field_actions.delete": "Veld verwijderen",
  "account_edit.field_actions.edit": "Veld bewerken",
  "account_edit.field_delete_modal.confirm": "Weet je zeker dat je dit aangepaste veld wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
  "account_edit.field_delete_modal.delete_button": "Verwijderen",
  "account_edit.field_delete_modal.title": "Aangepast veld verwijderen?",
  "account_edit.field_edit_modal.add_title": "Aangepast veld toevoegen",
  "account_edit.field_edit_modal.discard_confirm": "Weggooien",
  "account_edit.field_edit_modal.discard_message": "Je hebt niet-opgeslagen wijzigingen. Weet je zeker dat je ze wilt weggooien?",
  "account_edit.field_edit_modal.edit_title": "Aangepast veld bewerken",
  "account_edit.field_edit_modal.length_warning": "Aanbevolen tekenlimiet overschreden. Mobiele gebruikers zien mogelijk niet volledig je veld.",
  "account_edit.field_edit_modal.link_emoji_warning": "We raden aan om geen lokale emoji in combinatie met URL's te gebruiken. Aangepaste velden die beide bevatten worden alleen als tekst weergegeven, in plaats van als een link. Dit om verwarring voor de gebruiker te voorkomen.",
  "account_edit.field_edit_modal.name_hint": "Bijv. \"Persoonlijke website\"",
  "account_edit.field_edit_modal.name_label": "Label",
  "account_edit.field_edit_modal.url_warning": "Voeg {protocol} aan het begin toe om een link toe te voegen.",
  "account_edit.field_edit_modal.value_hint": "Bijv. \"https://example.me\"",
  "account_edit.field_edit_modal.value_label": "Waarde",
  "account_edit.field_reorder_modal.drag_cancel": "Slepen is geannuleerd. Veld \"{item}\" werd geschrapt.",
  "account_edit.field_reorder_modal.drag_end": "Veld \"{item}\" werd geschrapt.",
  "account_edit.field_reorder_modal.drag_instructions": "Druk op spatie of enter om de aangepaste velden te herschikken. Gebruik de pijltjestoetsen om het veld omhoog of omlaag te verplaatsen. Druk opnieuw op spatie of enter om het veld op diens nieuwe positie te laten vallen, of druk op escape om te annuleren.",
  "account_edit.field_reorder_modal.drag_move": "Veld \"{item}\" is verplaatst.",
  "account_edit.field_reorder_modal.drag_over": "Veld \"{item}\" is over \"{over}\" geplaatst.",
  "account_edit.field_reorder_modal.drag_start": "Opgepakt veld \"{item}\".",
  "account_edit.field_reorder_modal.handle_label": "Veld \"{item}\" slepen",
  "account_edit.field_reorder_modal.title": "Velden herschikken",
  "account_edit.image_alt_modal.add_title": "Alt-tekst toevoegen",
  "account_edit.image_alt_modal.details_content": "DOEN: <ul> <li>Beschrijf jezelf zoals afgebeeld</li> <li>Schrijf in de derde persoon (bijv. “Alex” in plaats van “ik”)</li> <li>Wees beknopt - een paar woorden is vaak genoeg</li> </ul> NIET DOEN: <ul> <li>Begin met “Foto van” - dit is overbodig voor schermlezers</li> </ul> VOORBEELD: <ul> <li>“Alex draagt een groen shirt en een bril”</li> </ul>",
  "account_edit.image_alt_modal.details_title": "Tips: Alt-tekst voor profielfoto's",
  "account_edit.image_alt_modal.edit_title": "Alt-tekst bewerken",
  "account_edit.image_alt_modal.text_hint": "Alt-text helpt gebruikers van schermlezers jouw inhoud te begrijpen.",
  "account_edit.image_alt_modal.text_label": "Alt-tekst",
  "account_edit.image_delete_modal.confirm": "Weet je zeker dat je deze afbeelding wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
  "account_edit.image_delete_modal.delete_button": "Verwijderen",
  "account_edit.image_delete_modal.title": "Afbeelding verwijderen?",
  "account_edit.image_edit.add_button": "Afbeelding toevoegen",
  "account_edit.image_edit.alt_add_button": "Alt-tekst toevoegen",
  "account_edit.image_edit.alt_edit_button": "Alt-tekst bewerken",
  "account_edit.image_edit.remove_button": "Afbeelding verwijderen",
  "account_edit.image_edit.replace_button": "Afbeelding vervangen",
  "account_edit.item_list.delete": "{name} verwijderen",
  "account_edit.item_list.edit": "{name} bewerken",
  "account_edit.name_modal.add_title": "Weergavenaam toevoegen",
  "account_edit.name_modal.edit_title": "Weergavenaam bewerken",
  "account_edit.profile_tab.button_label": "Aanpassen",
  "account_edit.profile_tab.hint.description": "Deze instellingen passen wat gebruikers op {server} zien in de officiële apps aan, maar ze zijn mogelijk niet van toepassing op gebruikers op andere servers en in apps van derden.",
  "account_edit.profile_tab.hint.title": "De weergave kan verschillen",
  "account_edit.profile_tab.show_featured.description": "'Uitgelicht' is een optioneel tabblad waarop je andere accounts kunt aanbevelen.",
  "account_edit.profile_tab.show_featured.title": "Tabblad 'Uitgelicht' tonen",
  "account_edit.profile_tab.show_media.description": "'Media' is een optioneel tabblad waarop jouw berichten met afbeeldingen, video en audio staan.",
  "account_edit.profile_tab.show_media.title": "Tabblad 'Media' tonen",
  "account_edit.profile_tab.show_media_replies.description": "Wanneer dit is ingeschakeld, worden op het tabblad Media zowel jouw berichten en reacties op berichten van anderen weergegeven.",
  "account_edit.profile_tab.show_media_replies.title": "Jouw reacties aan het tabblad 'Media' toevoegen",
  "account_edit.profile_tab.subtitle": "De tabbladen op je profiel aanpassen en wat er op wordt weergegeven.",
  "account_edit.profile_tab.title": "Instellingen voor tabblad Profiel",
  "account_edit.save": "Opslaan",
  "account_edit.upload_modal.back": "Terug",
  "account_edit.upload_modal.done": "Klaar",
  "account_edit.upload_modal.next": "Volgende",
  "account_edit.upload_modal.step_crop.zoom": "Zoom",
  "account_edit.upload_modal.step_upload.button": "Door bestanden bladeren",
  "account_edit.upload_modal.step_upload.dragging": "Hierheen slepen om te uploaden",
  "account_edit.upload_modal.step_upload.header": "Kies een afbeelding",
  "account_edit.upload_modal.step_upload.hint": "WEBP-, PNG-, GIF- of JPG-formaat, tot max. {limit}MB.{br}Afbeelding wordt geschaald naar {width}x{height}px.",
  "account_edit.upload_modal.title_add.avatar": "Profielfoto toevoegen",
  "account_edit.upload_modal.title_add.header": "Omslagfoto toevoegen",
  "account_edit.upload_modal.title_replace.avatar": "Profielfoto vervangen",
  "account_edit.upload_modal.title_replace.header": "Omslagfoto vervangen",
  "account_edit.verified_modal.details": "Maak je Mastodonprofiel geloofwaardig door links naar persoonlijke websites te verifiëren. Zo werkt het:",
  "account_edit.verified_modal.invisible_link.details": "Voeg de link aan de HTML van je website toe. Het belangrijkste onderdeel is rel=\"me\", waarmee wordt voorkomen dat websites met user-generated content geïmpersoneerd kunnen worden. Je kunt zelfs een <link>-tag gebruiken binnen de <head>-tag van je website in plaats van {tag}, maar de HTML moet zonder JavaScript toegankelijk zijn.",
  "account_edit.verified_modal.invisible_link.summary": "Hoe maak ik de link onzichtbaar?",
  "account_edit.verified_modal.step1.header": "Kopieer de onderstaande HTML-code en plak deze binnen de <head>-tag van je website",
  "account_edit.verified_modal.step2.details": "Als je je website al als een aangepast veld hebt toegevoegd, moet je deze verwijderen en opnieuw toevoegen om de verificatie te activeren.",
  "account_edit.verified_modal.step2.header": "Voeg je website toe als een aangepast veld",
  "account_edit.verified_modal.title": "Hoe voeg je een geverifieerde link toe",
  "account_edit_tags.add_tag": "#{tagName} toevoegen",
  "account_edit_tags.column_title": "Labels bewerken",
  "account_edit_tags.help_text": "Uitgelichte hashtags helpen gebruikers je profiel te ontdekken en om er interactie mee te communiceren. Ze verschijnen als filters op je Profielpagina onder het tabblad Activiteit.",
  "account_edit_tags.max_tags_reached": "Maximum aantal uitgelichte hashtags bereikt.",
  "account_edit_tags.search_placeholder": "Voer een hashtag in…",
  "account_edit_tags.suggestions": "Suggesties:",
  "account_edit_tags.tag_status_count": "{count, plural, one {# bericht} other {# berichten}}",
  "account_list.total": "{total, plural, one {# account} other {# accounts}}",
  "account_note.placeholder": "Klik om een opmerking toe te voegen",
  "admin.dashboard.daily_retention": "Retentiegraad van gebruikers per dag, vanaf registratie",
  "admin.dashboard.monthly_retention": "Retentiegraad van gebruikers per maand, vanaf registratie",
  "admin.dashboard.retention.average": "Gemiddelde",
  "admin.dashboard.retention.cohort": "Maand van registratie",
  "admin.dashboard.retention.cohort_size": "Nieuwe gebruikers",
  "admin.impact_report.instance_accounts": "Aantal accounts dat door deze actie wordt verwijderd",
  "admin.impact_report.instance_followers": "Aantal volgers die onze gebruikers zouden verliezen",
  "admin.impact_report.instance_follows": "Aantal volgers die hun gebruikers zouden verliezen",
  "admin.impact_report.title": "Overzicht van de gevolgen",
  "alert.rate_limited.message": "Probeer het nog een keer na {retry_time, time, medium}.",
  "alert.rate_limited.title": "Dataverkeer beperkt",
  "alert.unexpected.message": "Er deed zich een onverwachte fout voor",
  "alert.unexpected.title": "Oeps!",
  "alt_text_badge.title": "Alt-tekst",
  "alt_text_modal.add_alt_text": "Alt-tekst toevoegen",
  "alt_text_modal.add_text_from_image": "Tekst van afbeelding toevoegen",
  "alt_text_modal.cancel": "Annuleren",
  "alt_text_modal.change_thumbnail": "Miniatuur wijzigen",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Beschrijf dit voor doven en slechthorenden…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Beschrijf dit voor blinden en slechtzienden…",
  "alt_text_modal.done": "Klaar",
  "announcement.announcement": "Mededeling",
  "annual_report.announcement.action_build": "Bouw mijn Wrapstodon",
  "annual_report.announcement.action_dismiss": "Nee, bedankt",
  "annual_report.announcement.action_view": "Bekijk mijn Wrapstodon",
  "annual_report.announcement.description": "Ontdek meer over jouw engagement op Mastodon over het afgelopen jaar.",
  "annual_report.announcement.title": "Wrapstodon {year} is gearriveerd",
  "annual_report.nav_item.badge": "Nieuw",
  "annual_report.shared_page.donate": "Doneren",
  "annual_report.shared_page.footer": "Met {heart} gegenereerd door het Mastodonteam",
  "annual_report.shared_page.footer_server_info": "{username} gebruikt {domain}, een van de vele door Mastodon mogelijk gemaakte gemeenschappen.",
  "annual_report.summary.archetype.booster.desc_public": "{name} bleef op jacht naar berichten om te kunnen boosten, waardoor het geluid van andere gebruikers werd versterkt.",
  "annual_report.summary.archetype.booster.desc_self": "Jij bleef op jacht naar berichten om te kunnen boosten, waardoor je het geluid van andere gebruikers versterkte.",
  "annual_report.summary.archetype.booster.name": "De Boogschutter",
  "annual_report.summary.archetype.die_drei_fragezeichen": "???",
  "annual_report.summary.archetype.lurker.desc_public": "We weten dat {name} ergens in stilte van Mastodon aan het genieten was.",
  "annual_report.summary.archetype.lurker.desc_self": "We weten dat je ergens in stilte van Mastodon aan het genieten was.",
  "annual_report.summary.archetype.lurker.name": "De Stoïcijn",
  "annual_report.summary.archetype.oracle.desc_public": "{name} heeft meer nieuwe berichten dan reacties geplaatst, waardoor Mastodon fris en toekomstgericht blijft.",
  "annual_report.summary.archetype.oracle.desc_self": "Je hebt meer nieuwe berichten dan reacties geplaatst, waardoor Mastodon fris en toekomstgericht blijft.",
  "annual_report.summary.archetype.oracle.name": "Het Orakel",
  "annual_report.summary.archetype.pollster.desc_public": "{name} heeft meer polls aangemaakt dan andere soorten berichten, en daarmee de nieuwsgierigheid op Mastodon gecultiveerd.",
  "annual_report.summary.archetype.pollster.desc_self": "Je hebt meer polls aangemaakt dan andere soorten berichten, en daarmee de nieuwsgierigheid op Mastodon gecultiveerd.",
  "annual_report.summary.archetype.pollster.name": "De Dromer",
  "annual_report.summary.archetype.replier.desc_public": "{name} reageerde regelmatig op berichten van andere mensen, waardoor nieuwe discussies op Mastodon tot bloei kwamen.",
  "annual_report.summary.archetype.replier.desc_self": "Je reageerde regelmatig op berichten van andere mensen, waardoor nieuwe discussies op Mastodon tot bloei kwamen.",
  "annual_report.summary.archetype.replier.name": "De Vlinder",
  "annual_report.summary.archetype.reveal": "Onthul mijn archetype",
  "annual_report.summary.archetype.reveal_description": "Bedankt dat je deel uitmaakt van Mastodon! Tijd om te ontdekken welk archetype je in {year} belichaamde.",
  "annual_report.summary.archetype.title_public": "Het archetype van {name}",
  "annual_report.summary.archetype.title_self": "Jouw archetype",
  "annual_report.summary.close": "Sluiten",
  "annual_report.summary.copy_link": "Link kopiëren",
  "annual_report.summary.followers.new_followers": "{count, plural, one {nieuwe volger} other {nieuwe volgers}}",
  "annual_report.summary.highlighted_post.boost_count": "Dit bericht is {count, plural,  one {één keer} other {# keer}} geboost.",
  "annual_report.summary.highlighted_post.favourite_count": "Dit bericht is {count, plural, one {één keer} other {# keer}} als favoriet gemarkeerd.",
  "annual_report.summary.highlighted_post.reply_count": "Dit bericht heeft {count, plural, one {één reactie} other {# reacties}}.",
  "annual_report.summary.highlighted_post.title": "Meest populaire berichten",
  "annual_report.summary.most_used_app.most_used_app": "meest gebruikte app",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "meest gebruikte hashtag",
  "annual_report.summary.most_used_hashtag.used_count": "Je hebt deze hashtag in {count, plural, one{één bericht} other {# berichten}} gebruikt.",
  "annual_report.summary.most_used_hashtag.used_count_public": "{name} heeft deze hashtag in {count, plural, one {één bericht} other {# berichten}} gebruikt.",
  "annual_report.summary.new_posts.new_posts": "nieuwe berichten",
  "annual_report.summary.percentile.text": "<topLabel>Hiermee behoor je tot de top</topLabel><percentage></percentage><bottomLabel> van {domain}.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "We zullen Bernie niets vertellen.",
  "annual_report.summary.share_elsewhere": "Ergens anders delen",
  "annual_report.summary.share_message": "Ik heb het archetype {archetype}!",
  "annual_report.summary.share_on_mastodon": "Op Mastodon delen",
  "attachments_list.unprocessed": "(niet verwerkt)",
  "audio.hide": "Audio verbergen",
  "block_modal.remote_users_caveat": "We vragen de server {domain} om je besluit te respecteren. Het naleven hiervan is echter niet gegarandeerd, omdat sommige servers blokkades anders kunnen interpreteren. Openbare berichten zijn mogelijk nog steeds zichtbaar voor niet-ingelogde gebruikers.",
  "block_modal.show_less": "Minder tonen",
  "block_modal.show_more": "Meer tonen",
  "block_modal.they_cant_mention": "De persoon kan jou niet vermelden of volgen.",
  "block_modal.they_cant_see_posts": "De persoon kan jouw berichten niet zien en jij ook niet diens berichten.",
  "block_modal.they_will_know": "De persoon kan zien dat die wordt geblokkeerd.",
  "block_modal.title": "Gebruiker blokkeren?",
  "block_modal.you_wont_see_mentions": "Je ziet geen berichten meer die dit account vermelden.",
  "boost_modal.combo": "Je kunt {combo} klikken om dit de volgende keer over te slaan",
  "boost_modal.reblog": "Bericht boosten?",
  "boost_modal.undo_reblog": "Bericht niet langer boosten?",
  "bundle_column_error.copy_stacktrace": "Foutrapportage kopiëren",
  "bundle_column_error.error.body": "De opgevraagde pagina kon niet worden weergegeven. Dit kan het gevolg zijn van een fout in onze broncode, of van een compatibiliteitsprobleem met je webbrowser.",
  "bundle_column_error.error.title": "O nee!",
  "bundle_column_error.network.body": "Er is een fout opgetreden tijdens het laden van deze pagina. Dit kan veroorzaakt zijn door een tijdelijk probleem met je internetverbinding of met deze server.",
  "bundle_column_error.network.title": "Netwerkfout",
  "bundle_column_error.retry": "Opnieuw proberen",
  "bundle_column_error.return": "Terug naar start",
  "bundle_column_error.routing.body": "De opgevraagde pagina kon niet worden gevonden. Weet je zeker dat de URL in de adresbalk de juiste is?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Sluiten",
  "bundle_modal_error.message": "Er ging iets mis tijdens het laden van dit scherm.",
  "bundle_modal_error.retry": "Opnieuw proberen",
  "callout.dismiss": "Afwijzen",
  "carousel.current": "<sr>Bericht</sr> {current, number} / {max, number}",
  "carousel.slide": "Bericht {current, number} van {max, number}",
  "character_counter.recommended": "{currentLength}/{maxLength} aanbevolen tekens",
  "character_counter.required": "{currentLength}/{maxLength} tekens",
  "closed_registrations.other_server_instructions": "Omdat Mastodon gedecentraliseerd is, kun je op een andere server een account registreren en vanaf daar nog steeds met deze server communiceren.",
  "closed_registrations_modal.description": "Momenteel is het niet mogelijk om op {domain} een account aan te maken. Hou echter in gedachte dat om Mastodon te kunnen gebruiken het niet een vereiste is om op {domain} een account te hebben.",
  "closed_registrations_modal.find_another_server": "Een andere server zoeken",
  "closed_registrations_modal.preamble": "Mastodon is gedecentraliseerd. Op welke server je ook een account hebt, je kunt overal vandaan mensen op deze server volgen en er mee interactie hebben. Je kunt zelfs zelf een Mastodon-server hosten!",
  "closed_registrations_modal.title": "Registreren op Mastodon",
  "collection.share_modal.share_link_label": "Uitnodigingslink delen",
  "collection.share_modal.share_via_post": "Bericht op Mastodon",
  "collection.share_modal.share_via_system": "Delen met…",
  "collection.share_modal.title": "Verzameling delen",
  "collection.share_modal.title_new": "Je nieuwe verzameling delen!",
  "collection.share_template_other": "Bekijk deze coole verzameling: {link}",
  "collection.share_template_own": "Bekijk mijn nieuwe verzameling: {link}",
  "collections.account_count": "{count, plural, one {# account} other {# accounts}}",
  "collections.accounts.empty_description": "Tot {count} accounts die je volgt toevoegen",
  "collections.accounts.empty_title": "Deze verzameling is leeg",
  "collections.by_account": "door {account_handle}",
  "collections.collection_description": "Omschrijving",
  "collections.collection_language": "Taal",
  "collections.collection_language_none": "Geen",
  "collections.collection_name": "Naam",
  "collections.collection_topic": "Onderwerp",
  "collections.confirm_account_removal": "Weet je zeker dat je dit account uit deze verzameling wilt verwijderen?",
  "collections.content_warning": "Inhoudswaarschuwing",
  "collections.continue": "Doorgaan",
  "collections.create.accounts_subtitle": "Alleen accounts die je volgt en ontdekt willen worden, kunnen worden toegevoegd.",
  "collections.create.accounts_title": "Wie wil je aan deze verzameling toevoegen?",
  "collections.create.basic_details_title": "Basisgegevens",
  "collections.create.steps": "Stap {step}/{total}",
  "collections.create_a_collection_hint": "Een verzameling aanmaken om je favoriete accounts aan te bevelen of te delen met anderen.",
  "collections.create_collection": "Verzameling aanmaken",
  "collections.delete_collection": "Verzameling verwijderen",
  "collections.description_length_hint": "Maximaal 100 karakters",
  "collections.detail.accept_inclusion": "Oké",
  "collections.detail.accounts_heading": "Accounts",
  "collections.detail.loading": "Verzameling laden…",
  "collections.detail.other_accounts_count": "{count, plural, one {# ander account} other {# andere accounts}}",
  "collections.detail.revoke_inclusion": "Verwijder mij",
  "collections.detail.sensitive_content": "Gevoelige inhoud",
  "collections.detail.sensitive_note": "Deze verzameling bevat accounts en inhoud die mogelijk gevoelig zijn voor sommige gebruikers.",
  "collections.detail.share": "Deze verzameling delen",
  "collections.detail.you_were_added_to_this_collection": "Je bent aan deze verzameling toegevoegd",
  "collections.edit_details": "Gegevens bewerken",
  "collections.error_loading_collections": "Er is een fout opgetreden bij het laden van je verzamelingen.",
  "collections.hints.accounts_counter": "{count} / {max} accounts",
  "collections.last_updated_at": "Laatst bijgewerkt: {date}",
  "collections.manage_accounts": "Accounts beheren",
  "collections.mark_as_sensitive": "Als gevoelig markeren",
  "collections.mark_as_sensitive_hint": "Verbergt de omschrijving en de accounts van de verzameling achter een waarschuwing. De naam van de verzameling blijft zichtbaar.",
  "collections.name_length_hint": "Limiet van 40 tekens",
  "collections.new_collection": "Nieuwe verzameling",
  "collections.no_collections_yet": "Nog geen verzamelingen.",
  "collections.old_last_post_note": "Meer dan een week geleden voor het laatst een bericht geplaatst",
  "collections.remove_account": "Dit account verwijderen",
  "collections.report_collection": "Deze verzameling rapporteren",
  "collections.revoke_collection_inclusion": "Mezelf uit deze verzameling verwijderen",
  "collections.revoke_inclusion.confirmation": "Je bent uit \"{collection}\" verwijderd",
  "collections.revoke_inclusion.error": "Er is een fout opgetreden. Probeer het later opnieuw.",
  "collections.search_accounts_label": "Naar accounts zoeken om toe te voegen…",
  "collections.search_accounts_max_reached": "Je hebt het maximum aantal accounts toegevoegd",
  "collections.sensitive": "Gevoelig",
  "collections.topic_hint": "Voeg een hashtag toe die anderen helpt het hoofdonderwerp van deze verzameling te begrijpen.",
  "collections.topic_special_chars_hint": "Speciale tekens worden bij het opslaan verwijderd",
  "collections.view_collection": "Verzameling bekijken",
  "collections.view_other_collections_by_user": "Bekijk andere verzamelingen van deze gebruiker",
  "collections.visibility_public": "Openbaar",
  "collections.visibility_public_hint": "Te zien onder zoekresultaten en in andere gebieden waar aanbevelingen verschijnen.",
  "collections.visibility_title": "Zichtbaarheid",
  "collections.visibility_unlisted": "Niet zichtbaar",
  "collections.visibility_unlisted_hint": "Zichtbaar voor iedereen met een link. Verborgen onder zoekresultaten en aanbevelingen.",
  "column.about": "Over",
  "column.blocks": "Geblokkeerde gebruikers",
  "column.bookmarks": "Bladwijzers",
  "column.collections": "Mijn verzamelingen",
  "column.community": "Lokale tijdlijn",
  "column.create_list": "Lijst aanmaken",
  "column.direct": "Privéberichten",
  "column.directory": "Gebruikersgids",
  "column.domain_blocks": "Geblokkeerde servers",
  "column.edit_list": "Lijst bewerken",
  "column.favourites": "Favorieten",
  "column.firehose": "Openbare tijdlijnen",
  "column.firehose_local": "Lokale tijdlijn",
  "column.firehose_singular": "Openbare tijdlijn",
  "column.follow_requests": "Volgverzoeken",
  "column.home": "Start",
  "column.list_members": "Lijstleden beheren",
  "column.lists": "Lijsten",
  "column.mutes": "Genegeerde gebruikers",
  "column.notifications": "Meldingen",
  "column.pins": "Vastgezette berichten",
  "column.public": "Globale tijdlijn",
  "column_back_button.label": "Terug",
  "column_header.hide_settings": "Instellingen verbergen",
  "column_header.moveLeft_settings": "Kolom naar links verplaatsen",
  "column_header.moveRight_settings": "Kolom naar rechts verplaatsen",
  "column_header.pin": "Vastmaken",
  "column_header.show_settings": "Instellingen tonen",
  "column_header.unpin": "Losmaken",
  "column_search.cancel": "Annuleren",
  "combobox.close_results": "Resultaten sluiten",
  "combobox.loading": "Laden",
  "combobox.no_results_found": "Geen resultaten voor deze zoekopdracht",
  "combobox.open_results": "Resultaten openen",
  "combobox.results_available": "{count, plural, one {# suggestie} other {# suggesties}} beschikbaar. Gebruik de pijltjes omhoog en omlaag om te navigeren. Druk op Enter om te selecteren.",
  "community.column_settings.local_only": "Alleen lokaal",
  "community.column_settings.media_only": "Alleen media",
  "community.column_settings.remote_only": "Alleen andere servers",
  "compose.error.blank_post": "Bericht mag niet leeg zijn.",
  "compose.language.change": "Taal veranderen",
  "compose.language.search": "Talen zoeken...",
  "compose.published.body": "Bericht gepubliceerd.",
  "compose.published.open": "Tonen",
  "compose.saved.body": "Bericht opgeslagen.",
  "compose_form.direct_message_warning_learn_more": "Meer leren",
  "compose_form.encryption_warning": "Berichten op Mastodon worden, net zoals op andere social media, niet end-to-end versleuteld. Deel daarom geen gevoelige informatie via Mastodon.",
  "compose_form.hashtag_warning": "Dit bericht valt niet onder een hashtag te bekijken, omdat deze niet openbaar is. Alleen openbare berichten kunnen via hashtags gevonden worden.",
  "compose_form.lock_disclaimer": "Jouw account is niet {locked}. Iedereen kan jou volgen en kan de berichten zien die je alleen aan jouw volgers hebt gericht.",
  "compose_form.lock_disclaimer.lock": "vergrendeld",
  "compose_form.placeholder": "Wat wil je kwijt?",
  "compose_form.poll.duration": "Duur van de peiling",
  "compose_form.poll.multiple": "Meerkeuze",
  "compose_form.poll.option_placeholder": "Optie {number}",
  "compose_form.poll.single": "Enkele keuze",
  "compose_form.poll.switch_to_multiple": "Peiling wijzigen om meerdere keuzes toe te staan",
  "compose_form.poll.switch_to_single": "Peiling wijzigen om een enkele keuze toe te staan",
  "compose_form.poll.type": "Stijl",
  "compose_form.publish": "Toot",
  "compose_form.reply": "Reageren",
  "compose_form.save_changes": "Bijwerken",
  "compose_form.spoiler.marked": "Inhoudswaarschuwing verwijderen",
  "compose_form.spoiler.unmarked": "Inhoudswaarschuwing toevoegen",
  "compose_form.spoiler_placeholder": "Inhoudswaarschuwing (optioneel)",
  "confirmation_modal.cancel": "Annuleren",
  "confirmations.block.confirm": "Blokkeren",
  "confirmations.delete.confirm": "Verwijderen",
  "confirmations.delete.message": "Weet je het zeker dat je dit bericht wilt verwijderen?",
  "confirmations.delete.title": "Bericht verwijderen?",
  "confirmations.delete_collection.confirm": "Verwijderen",
  "confirmations.delete_collection.message": "Deze actie kan niet ongedaan worden gemaakt.",
  "confirmations.delete_collection.title": "\"{name}\" verwijderen?",
  "confirmations.delete_list.confirm": "Verwijderen",
  "confirmations.delete_list.message": "Weet je zeker dat je deze lijst definitief wilt verwijderen?",
  "confirmations.delete_list.title": "Lijst verwijderen?",
  "confirmations.discard_draft.confirm": "Verwijderen en doorgaan",
  "confirmations.discard_draft.edit.cancel": "Bewerken bericht hervatten",
  "confirmations.discard_draft.edit.message": "Door door te gaan verwijder je alle wijzigingen in het bericht dat je op dit moment aan het bewerken bent.",
  "confirmations.discard_draft.edit.title": "Wijzigingen aan je bericht verwijderen?",
  "confirmations.discard_draft.post.cancel": "Conceptbericht hervatten",
  "confirmations.discard_draft.post.message": "Door door te gaan verwijder je het bericht dat je op dit moment aan het schrijven bent.",
  "confirmations.discard_draft.post.title": "Conceptbericht verwijderen?",
  "confirmations.discard_edit_media.confirm": "Verwijderen",
  "confirmations.discard_edit_media.message": "Je hebt niet-opgeslagen wijzigingen in de mediabeschrijving of voorvertonning, wil je deze toch verwijderen?",
  "confirmations.follow_to_collection.confirm": "Volgen en aan verzameling toevoegen",
  "confirmations.follow_to_collection.message": "Je moet {name} volgen om dit account aan een verzameling toe te kunnen voegen.",
  "confirmations.follow_to_collection.title": "Account volgen?",
  "confirmations.follow_to_list.confirm": "Volgen en toevoegen aan de lijst",
  "confirmations.follow_to_list.message": "Je moet {name} volgen om dit account aan een lijst toe te kunnen voegen.",
  "confirmations.follow_to_list.title": "Gebruiker volgen?",
  "confirmations.logout.confirm": "Uitloggen",
  "confirmations.logout.message": "Weet je zeker dat je wilt uitloggen?",
  "confirmations.logout.title": "Uitloggen?",
  "confirmations.missing_alt_text.confirm": "Alt-tekst toevoegen",
  "confirmations.missing_alt_text.message": "Je bericht bevat media zonder alt-tekst. Het toevoegen van beschrijvingen helpt je om je inhoud toegankelijk te maken voor meer mensen.",
  "confirmations.missing_alt_text.secondary": "Toch plaatsen",
  "confirmations.missing_alt_text.title": "Alt-tekst toevoegen?",
  "confirmations.mute.confirm": "Negeren",
  "confirmations.private_quote_notify.cancel": "Terug naar bewerken",
  "confirmations.private_quote_notify.confirm": "Bericht plaatsen",
  "confirmations.private_quote_notify.do_not_show_again": "Dit bericht niet meer aan mij tonen",
  "confirmations.private_quote_notify.message": "De persoon die je citeert en andere vermelde personen krijgen een melding en kunnen jouw bericht bekijken, zelfs als ze je niet volgen.",
  "confirmations.private_quote_notify.title": "Met volgers en vermelde gebruikers delen?",
  "confirmations.quiet_post_quote_info.dismiss": "Herinner me er niet nogmaals aan",
  "confirmations.quiet_post_quote_info.got_it": "Begrepen",
  "confirmations.quiet_post_quote_info.message": "Wanneer je een minder openbaar bericht citeert, verschijnt jouw bericht niet onder trends.",
  "confirmations.quiet_post_quote_info.title": "Berichten die minder openbaar zijn citeren",
  "confirmations.redraft.confirm": "Verwijderen en herschrijven",
  "confirmations.redraft.message": "Weet je zeker dat je dit bericht wilt verwijderen en herschrijven? Je verliest wel de boosts en favorieten, en de reacties op het originele bericht raak je kwijt.",
  "confirmations.redraft.title": "Bericht verwijderen en herschrijven?",
  "confirmations.remove_from_followers.confirm": "Volger verwijderen",
  "confirmations.remove_from_followers.message": "{name} zal je niet meer volgen. Weet je zeker dat je wilt doorgaan?",
  "confirmations.remove_from_followers.title": "Volger verwijderen?",
  "confirmations.revoke_collection_inclusion.confirm": "Verwijder mij",
  "confirmations.revoke_collection_inclusion.message": "Deze actie is definitief en de curator kan je later niet opnieuw aan de verzameling toevoegen.",
  "confirmations.revoke_collection_inclusion.title": "Jezelf uit deze collectie verwijderen?",
  "confirmations.revoke_quote.confirm": "Bericht verwijderen",
  "confirmations.revoke_quote.message": "Deze actie kan niet ongedaan worden gemaakt.",
  "confirmations.revoke_quote.title": "Bericht verwijderen?",
  "confirmations.unblock.confirm": "Deblokkeren",
  "confirmations.unblock.title": "{name} deblokkeren?",
  "confirmations.unfollow.confirm": "Ontvolgen",
  "confirmations.unfollow.title": "{name} ontvolgen?",
  "confirmations.withdraw_request.confirm": "Verzoek intrekken",
  "confirmations.withdraw_request.title": "Verzoek intrekken om {name} te volgen?",
  "content_warning.hide": "Bericht verbergen",
  "content_warning.show": "Alsnog tonen",
  "content_warning.show_more": "Meer tonen",
  "content_warning.show_short": "Tonen",
  "conversation.delete": "Gesprek verwijderen",
  "conversation.mark_as_read": "Als gelezen markeren",
  "conversation.open": "Gesprek tonen",
  "conversation.with": "Met {names}",
  "copy_icon_button.copied": "Gekopieerd naar klembord",
  "copy_icon_button.copy_this_text": "Link naar klembord kopiëren",
  "copypaste.copied": "Gekopieerd",
  "copypaste.copy_to_clipboard": "Naar klembord kopiëren",
  "directory.federated": "Fediverse (wat bekend is)",
  "directory.local": "Alleen {domain}",
  "directory.new_arrivals": "Nieuwe accounts",
  "directory.recently_active": "Onlangs actief",
  "disabled_account_banner.account_settings": "Accountinstellingen",
  "disabled_account_banner.text": "Jouw account {disabledAccount} is momenteel uitgeschakeld.",
  "dismissable_banner.community_timeline": "Dit zijn de meest recente openbare berichten van gebruikers met een account op {domain}.",
  "dismissable_banner.dismiss": "Sluiten",
  "dismissable_banner.public_timeline": "Dit zijn de meest recente openbare berichten van mensen op de fediverse die mensen op {domain} volgen.",
  "domain_block_modal.block": "Server blokkeren",
  "domain_block_modal.block_account_instead": "Alleen {name} blokkeren",
  "domain_block_modal.they_can_interact_with_old_posts": "Mensen op deze server kunnen interactie hebben met jouw oude berichten.",
  "domain_block_modal.they_cant_follow": "Niemand op deze server kan jou volgen.",
  "domain_block_modal.they_wont_know": "Ze krijgen niet te weten dat ze worden geblokkeerd.",
  "domain_block_modal.title": "Server blokkeren?",
  "domain_block_modal.you_will_lose_num_followers": "Je verliest {followersCount, plural, one {{followersCountDisplay} volger} other {{followersCountDisplay} volgers}} en {followingCount, plural, one {{followingCountDisplay} persoon die jij volgt} other {{followingCountDisplay} personen die jij volgt}}.",
  "domain_block_modal.you_will_lose_relationships": "Je verliest alle volgers en mensen die je volgt van deze server.",
  "domain_block_modal.you_wont_see_posts": "Je ziet geen berichten of meldingen meer van gebruikers op deze server.",
  "domain_pill.activitypub_lets_connect": "Het zorgt ervoor dat je niet alleen maar kunt verbinden en communiceren met mensen op Mastodon, maar ook met andere sociale apps.",
  "domain_pill.activitypub_like_language": "ActivityPub is de taal die Mastodon met andere sociale netwerken spreekt.",
  "domain_pill.server": "Server",
  "domain_pill.their_handle": "Hun fediverse-adres:",
  "domain_pill.their_server": "Hun digitale thuis, waar al hun berichten zich bevinden.",
  "domain_pill.their_username": "Hun unieke identificatie-adres op hun server. Het is mogelijk dat er gebruikers met dezelfde gebruikersnaam op verschillende servers te vinden zijn.",
  "domain_pill.username": "Gebruikersnaam",
  "domain_pill.whats_in_a_handle": "Wat is een fediverse-adres?",
  "domain_pill.who_they_are": "Omdat je aan een fediverse-adres kunt zien hoe iemand heet en op welke server die zich bevindt, kun je met mensen op het door <button>ActivityPub aangedreven</button> sociale web (fediverse) communiceren.",
  "domain_pill.who_you_are": "Omdat je aan jouw fediverse-adres kunt zien hoe je heet en op welke server je je bevindt, kunnen mensen op het door <button>ActivityPub aangedreven</button> sociale web (fediverse) met jou communiceren.",
  "domain_pill.your_handle": "Jouw fediverse-adres:",
  "domain_pill.your_server": "Jouw digitale thuis, waar al jouw berichten zich bevinden. Is deze server toch niet naar jouw wens? Dan kun je op elk moment naar een andere server verhuizen en ook jouw volgers overbrengen.",
  "domain_pill.your_username": "Jouw unieke identificatie-adres op deze server. Het is mogelijk dat er gebruikers met dezelfde gebruikersnaam op verschillende servers te vinden zijn.",
  "dropdown.empty": "Selecteer een optie",
  "email_subscriptions.email": "E-mailadres",
  "email_subscriptions.form.action": "Abonneren",
  "email_subscriptions.form.disclaimer": "Je kunt je op elk gewenst moment afmelden. Raadpleeg het <a>Privacybeleid</a> voor meer informatie.",
  "email_subscriptions.form.lead": "Krijg berichten in je inbox zonder een Mastodonaccount aan te hoeven maken.",
  "email_subscriptions.form.title": "Op e-mailupdates van {name} abonneren",
  "email_subscriptions.submitted.lead": "Kijk in je inbox voor een e-mail waarmee je het abbonement op de e-mailupdates kunt bevestigen.",
  "email_subscriptions.submitted.title": "Nog één stap",
  "email_subscriptions.validation.email.blocked": "Geblokkeerde e-mailprovider",
  "email_subscriptions.validation.email.invalid": "Ongeldig e-mailadres",
  "embed.instructions": "Embed dit bericht op jouw website door de onderstaande code te kopiëren.",
  "embed.preview": "Zo komt het eruit te zien:",
  "emoji_button.activity": "Activiteiten",
  "emoji_button.clear": "Leegmaken",
  "emoji_button.custom": "Lokale emoji’s",
  "emoji_button.flags": "Vlaggen",
  "emoji_button.food": "Eten en drinken",
  "emoji_button.label": "Emoji toevoegen",
  "emoji_button.nature": "Natuur",
  "emoji_button.not_found": "Geen overeenkomende emojis gevonden",
  "emoji_button.objects": "Voorwerpen",
  "emoji_button.people": "Mensen",
  "emoji_button.recent": "Vaak gebruikt",
  "emoji_button.search": "Zoeken...",
  "emoji_button.search_results": "Zoekresultaten",
  "emoji_button.symbols": "Symbolen",
  "emoji_button.travel": "Reizen en locaties",
  "empty_column.account_featured.me": "Je hebt nog niets uitgelicht. Wist je dat je een aantal van jouw berichten, jouw meest gebruikte hashtags en zelfs accounts van je vrienden op je profiel kunt uitlichten?",
  "empty_column.account_featured.other": "{acct} heeft nog niets uitgelicht. Wist je dat je een aantal van jouw berichten, jouw meest gebruikte hashtags en zelfs accounts van je vrienden op je profiel kunt uitlichten?",
  "empty_column.account_featured_other.unknown": "Dit account heeft nog niets uitgelicht.",
  "empty_column.account_hides_collections": "Deze gebruiker heeft ervoor gekozen deze informatie niet beschikbaar te maken",
  "empty_column.account_suspended": "Account opgeschort",
  "empty_column.account_timeline": "Hier zijn geen berichten!",
  "empty_column.account_unavailable": "Profiel is niet beschikbaar",
  "empty_column.blocks": "Je hebt nog geen gebruikers geblokkeerd.",
  "empty_column.bookmarked_statuses": "Jij hebt nog geen berichten aan je bladwijzers toegevoegd. Wanneer je er een aan jouw bladwijzers toevoegt, valt deze hier te zien.",
  "empty_column.community": "De lokale tijdlijn is nog leeg. Plaats een openbaar bericht om de spits af te bijten!",
  "empty_column.direct": "Je hebt nog geen privéberichten. Wanneer je er een verstuurt of ontvangt, komen deze hier te staan.",
  "empty_column.disabled_feed": "Deze tijdlijn is uitgeschakeld door je serverbeheerders.",
  "empty_column.domain_blocks": "Er zijn nog geen geblokkeerde servers.",
  "empty_column.explore_statuses": "Momenteel zijn er geen trends. Kom later terug!",
  "empty_column.favourited_statuses": "Jij hebt nog geen favoriete berichten. Wanneer je een bericht als favoriet markeert, valt deze hier te zien.",
  "empty_column.favourites": "Niemand heeft dit bericht nog als favoriet gemarkeerd. Wanneer iemand dit doet, valt dat hier te zien.",
  "empty_column.follow_requests": "Je hebt nog geen volgverzoeken ontvangen. Wanneer je er een ontvangt, valt dat hier te zien.",
  "empty_column.followed_tags": "Je hebt nog geen hashtags gevolgd. Nadat je dit doet, komen deze hier te staan.",
  "empty_column.hashtag": "Er is nog niks te vinden onder deze hashtag.",
  "empty_column.home": "Deze tijdlijn is leeg! Volg meer mensen om het te vullen.",
  "empty_column.list": "Er is nog niks te zien in deze lijst. Wanneer lijstleden nieuwe berichten plaatsen, zijn deze hier te zien.",
  "empty_column.mutes": "Jij hebt nog geen gebruikers genegeerd.",
  "empty_column.notification_requests": "Helemaal leeg! Er is hier niets. Wanneer je nieuwe meldingen ontvangt, verschijnen deze hier volgens jouw instellingen.",
  "empty_column.notifications": "Je hebt nog geen meldingen. Begin met iemand een gesprek.",
  "empty_column.public": "Er is hier helemaal niks! Plaatst een openbaar bericht of volg mensen van andere servers om het te vullen",
  "empty_state.no_results": "Geen resultaten",
  "error.no_hashtag_feed_access": "Registreren of inloggen om de hashtag te bekijken of te volgen.",
  "error.unexpected_crash.explanation": "Als gevolg van een bug in onze broncode of als gevolg van een compatibiliteitsprobleem met jouw webbrowser, kan deze pagina niet goed worden weergegeven.",
  "error.unexpected_crash.explanation_addons": "Deze pagina kon niet correct geladen worden. Deze fout wordt waarschijnlijk door een browser-add-on of een automatische vertalingshulpmiddel veroorzaakt.",
  "error.unexpected_crash.next_steps": "Probeer deze pagina te vernieuwen. Wanneer dit niet helpt is het nog steeds mogelijk om Mastodon in een andere webbrowser of mobiele app te gebruiken.",
  "error.unexpected_crash.next_steps_addons": "Probeer deze uit te schakelen en de pagina te verversen. Wanneer dat niet helpt, kun je Mastodon nog altijd met een andere webbrowser of mobiele app gebruiken.",
  "errors.unexpected_crash.copy_stacktrace": "Stacktrace naar klembord kopiëren",
  "errors.unexpected_crash.report_issue": "Technisch probleem melden",
  "explore.suggested_follows": "Mensen",
  "explore.title": "Trends",
  "explore.trending_links": "Nieuws",
  "explore.trending_statuses": "Berichten",
  "explore.trending_tags": "Hashtags",
  "featured_carousel.current": "<sr>Bericht</sr> {current, number} / {max, number}",
  "featured_carousel.header": "{count, plural, one {Vastgezet bericht} other {Vastgezette berichten}}",
  "featured_carousel.slide": "Bericht {current, number} van {max, number}",
  "featured_tags.more_items": "+{count}",
  "featured_tags.suggestions": "Je hebt de afgelopen periode over {items} bericht. Deze toevoegen als uitgelichte hashtags?",
  "featured_tags.suggestions.add": "Toevoegen",
  "featured_tags.suggestions.added": "Je kunt je uitgelichte hashtags beheren onder <link>Profiel bewerken > Uitgelichte hashtags</link>.",
  "featured_tags.suggestions.dismiss": "Nee, bedankt",
  "filter_modal.added.context_mismatch_explanation": "Deze filtercategorie is niet van toepassing op de context waarin je dit bericht hebt benaderd. Als je wilt dat het bericht ook in deze context wordt gefilterd, moet je het filter bewerken.",
  "filter_modal.added.context_mismatch_title": "Context komt niet overeen!",
  "filter_modal.added.expired_explanation": "Deze filtercategorie is verlopen. Je moet de vervaldatum wijzigen om de categorie toe te kunnen passen.",
  "filter_modal.added.expired_title": "Filter verlopen!",
  "filter_modal.added.review_and_configure": "Ga naar {settings_link} om deze filtercategorie opnieuw te bekijken en verder te configureren.",
  "filter_modal.added.review_and_configure_title": "Filterinstellingen",
  "filter_modal.added.settings_link": "instellingspagina",
  "filter_modal.added.short_explanation": "Dit bericht is toegevoegd aan de volgende filtercategorie: {title}.",
  "filter_modal.added.title": "Filter toegevoegd!",
  "filter_modal.select_filter.context_mismatch": "is niet van toepassing op deze context",
  "filter_modal.select_filter.expired": "verlopen",
  "filter_modal.select_filter.prompt_new": "Nieuwe categorie: {name}",
  "filter_modal.select_filter.search": "Zoeken of toevoegen",
  "filter_modal.select_filter.subtitle": "Een bestaande categorie gebruiken of een nieuwe aanmaken",
  "filter_modal.select_filter.title": "Dit bericht filteren",
  "filter_modal.title.status": "Een bericht filteren",
  "filter_warning.matches_filter": "Komt overeen met filter \"<span>{title}</span>\"",
  "filtered_notifications_banner.pending_requests": "Van {count, plural, =0 {niemand} one {een persoon} other {# personen}} die je mogelijk kent",
  "filtered_notifications_banner.title": "Gefilterde meldingen",
  "firehose.all": "Alles",
  "firehose.local": "Deze server",
  "firehose.remote": "Andere servers",
  "follow_request.authorize": "Goedkeuren",
  "follow_request.reject": "Afwijzen",
  "follow_requests.unlocked_explanation": "Ook al is jouw account niet besloten, de medewerkers van {domain} denken dat jij misschien de volgende volgverzoeken handmatig wil controleren.",
  "follow_suggestions.curated_suggestion": "Speciaal geselecteerd",
  "follow_suggestions.dismiss": "Niet meer weergeven",
  "follow_suggestions.featured_longer": "Handmatig geselecteerd door het team van {domain}",
  "follow_suggestions.friends_of_friends_longer": "Populair onder mensen die je volgt",
  "follow_suggestions.hints.featured": "Deze gebruiker is handmatig geselecteerd door het team van {domain}.",
  "follow_suggestions.hints.friends_of_friends": "Deze gebruiker is populair onder de mensen die jij volgt.",
  "follow_suggestions.hints.most_followed": "Deze gebruiker is een van de meest gevolgde gebruikers op {domain}.",
  "follow_suggestions.hints.most_interactions": "Deze gebruiker is de laatste tijd erg populair op {domain}.",
  "follow_suggestions.hints.similar_to_recently_followed": "Deze gebruiker is vergelijkbaar met gebruikers die je recentelijk hebt gevolgd.",
  "follow_suggestions.personalized_suggestion": "Gepersonaliseerde aanbeveling",
  "follow_suggestions.popular_suggestion": "Populaire aanbeveling",
  "follow_suggestions.popular_suggestion_longer": "Populair op {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Vergelijkbaar met accounts die je recentelijk bent gaan volgen",
  "follow_suggestions.view_all": "Alles weergeven",
  "follow_suggestions.who_to_follow": "Wie te volgen",
  "followed_tags": "Gevolgde hashtags",
  "followers.hide_other_followers": "Deze gebruiker heeft ervoor gekozen diens andere volgers niet zichtbaar te maken",
  "followers.title": "{name} volgen",
  "following.hide_other_following": "Deze gebruiker heeft ervoor gekozen de rest van diens gevolgde accounts niet zichtbaar te maken",
  "following.title": "Gevolgd door {name}",
  "footer.about": "Over",
  "footer.about_mastodon": "Over Mastodon",
  "footer.about_server": "Over {domain}",
  "footer.about_this_server": "Over",
  "footer.directory": "Gebruikersgids",
  "footer.get_app": "App downloaden",
  "footer.keyboard_shortcuts": "Sneltoetsen",
  "footer.privacy_policy": "Privacybeleid",
  "footer.source_code": "Broncode bekijken",
  "footer.status": "Status",
  "footer.terms_of_service": "Gebruiksvoorwaarden",
  "form_error.blank": "Veld mag niet leeg zijn.",
  "form_field.optional": "(optioneel)",
  "generic.saved": "Opgeslagen",
  "getting_started.heading": "Aan de slag",
  "hashtag.admin_moderation": "Moderatie-omgeving van #{name} openen",
  "hashtag.browse": "Berichten met #{hashtag} bekijken",
  "hashtag.browse_from_account": "Berichten van @{name} met #{hashtag} bekijken",
  "hashtag.column_header.tag_mode.all": "en {additional}",
  "hashtag.column_header.tag_mode.any": "of {additional}",
  "hashtag.column_header.tag_mode.none": "zonder {additional}",
  "hashtag.column_settings.select.no_options_message": "Geen aanbevelingen gevonden",
  "hashtag.column_settings.select.placeholder": "Vul hashtags in…",
  "hashtag.column_settings.tag_mode.all": "Allemaal",
  "hashtag.column_settings.tag_mode.any": "Een van deze",
  "hashtag.column_settings.tag_mode.none": "Geen van deze",
  "hashtag.column_settings.tag_toggle": "Additionele tags aan deze kolom toevoegen",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} deelnemer} other {{counter} deelnemers}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} bericht} other {{counter} berichten}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} bericht} other {{counter} berichten}} vandaag",
  "hashtag.feature": "Op profiel uitlichten",
  "hashtag.follow": "Hashtag volgen",
  "hashtag.mute": "#{hashtag} negeren",
  "hashtag.unfeature": "Niet op profiel uitlichten",
  "hashtag.unfollow": "Hashtag ontvolgen",
  "hashtags.and_other": "…en {count, plural, one {}other {# meer}}",
  "hints.profiles.followers_may_be_missing": "Volgers voor dit profiel kunnen ontbreken.",
  "hints.profiles.follows_may_be_missing": "De volgers voor dit profiel kunnen ontbreken.",
  "hints.profiles.posts_may_be_missing": "Er ontbreken mogelijk berichten van dit profiel.",
  "hints.profiles.see_more_followers": "Bekijk meer volgers op {domain}",
  "hints.profiles.see_more_follows": "Bekijk meer gevolgde accounts op {domain}",
  "hints.profiles.see_more_posts": "Bekijk meer berichten op {domain}",
  "home.column_settings.show_quotes": "Citaten tonen",
  "home.column_settings.show_reblogs": "Boosts tonen",
  "home.column_settings.show_replies": "Reacties tonen",
  "home.hide_announcements": "Mededelingen verbergen",
  "home.pending_critical_update.body": "Update alstublieft zo snel mogelijk jouw Mastodon-server!",
  "home.pending_critical_update.link": "Bekijk updates",
  "home.pending_critical_update.title": "Kritieke beveiligingsupdate beschikbaar!",
  "home.show_announcements": "Mededelingen tonen",
  "ignore_notifications_modal.disclaimer": "Mastodon kan gebruikers niet informeren dat je hun meldingen hebt genegeerd. Meldingen negeren zal niet voorkomen dat de berichten zelf worden verzonden.",
  "ignore_notifications_modal.filter_instead": "In plaats daarvan filteren",
  "ignore_notifications_modal.filter_to_act_users": "Je bent nog steeds in staat om volgverzoeken goed- of af te keuren, en om gebruikers te rapporteren",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Filteren voorkomt potentiële verwarring",
  "ignore_notifications_modal.filter_to_review_separately": "Je kunt gefilterde meldingen afzonderlijk beoordelen",
  "ignore_notifications_modal.ignore": "Meldingen negeren",
  "ignore_notifications_modal.limited_accounts_title": "Meldingen van beperkte accounts negeren?",
  "ignore_notifications_modal.new_accounts_title": "Meldingen van nieuwe accounts negeren?",
  "ignore_notifications_modal.not_followers_title": "Meldingen negeren van mensen die jou niet volgen?",
  "ignore_notifications_modal.not_following_title": "Meldingen negeren van mensen die je niet volgt?",
  "ignore_notifications_modal.private_mentions_title": "Meldingen negeren van ongevraagde privéberichten?",
  "info_button.label": "Help",
  "info_button.what_is_alt_text": "<h1>Wat is alt-tekst?</h1> <p>Alt-tekst biedt beschrijvingen van afbeeldingen voor mensen met een visuele beperking, voor verbindingen met lage internetsnelheid of mensen die op zoek zijn naar extra context.</p> <p>Je kunt de toegankelijkheid en de begrijpelijkheid voor iedereen verbeteren door heldere, beknopte en objectieve alt-teksten te schrijven.</p> <ul> <li>Leg belangrijke elementen vast</li> <li>Tekst in afbeeldingen samenvatten</li> <li>Een eenvoudige zinsbouw gebruiken</li> <li>Overbodige informatie vermijden</li> <li>Voor complexe diagrammen of kaarten alleen op trends en belangrijke bevindingen focussen</li> </ul>",
  "interaction_modal.action": "Wanneer je met het bericht van {name} interactie wil hebben, moet je met jouw account op jouw eigen Mastodon-server inloggen.",
  "interaction_modal.go": "Ga",
  "interaction_modal.no_account_yet": "Heb je nog geen account?",
  "interaction_modal.on_another_server": "Op een andere server",
  "interaction_modal.on_this_server": "Op deze server",
  "interaction_modal.title": "Inloggen om door te gaan",
  "interaction_modal.username_prompt": "Bijv. {example}",
  "intervals.full.days": "{number, plural, one {# dag} other {# dagen}}",
  "intervals.full.hours": "{number, plural, one {# uur} other {# uur}}",
  "intervals.full.minutes": "{number, plural, one {# minuut} other {# minuten}}",
  "keyboard_shortcuts.back": "Ga terug",
  "keyboard_shortcuts.blocked": "Geblokkeerde gebruikers tonen",
  "keyboard_shortcuts.boost": "Bericht boosten",
  "keyboard_shortcuts.column": "Op één van de kolommen focussen",
  "keyboard_shortcuts.compose": "Tekstveld om een bericht te schrijven focussen",
  "keyboard_shortcuts.description": "Omschrijving",
  "keyboard_shortcuts.direct": "Kolom met privéberichten openen",
  "keyboard_shortcuts.down": "Naar beneden in de lijst bewegen",
  "keyboard_shortcuts.enter": "Volledig bericht tonen",
  "keyboard_shortcuts.explore": "Trends openen",
  "keyboard_shortcuts.favourite": "Bericht als favoriet markeren",
  "keyboard_shortcuts.favourites": "Lijst met favorieten tonen",
  "keyboard_shortcuts.federated": "Globale tijdlijn tonen",
  "keyboard_shortcuts.heading": "Sneltoetsen",
  "keyboard_shortcuts.home": "Starttijdlijn tonen",
  "keyboard_shortcuts.hotkey": "Sneltoets",
  "keyboard_shortcuts.legend": "Deze legenda tonen",
  "keyboard_shortcuts.load_more": "\"Meer laden\"-knop focussen",
  "keyboard_shortcuts.local": "Lokale tijdlijn tonen",
  "keyboard_shortcuts.mention": "Account vermelden",
  "keyboard_shortcuts.muted": "Genegeerde gebruikers tonen",
  "keyboard_shortcuts.my_profile": "Jouw profiel tonen",
  "keyboard_shortcuts.notifications": "Meldingen tonen",
  "keyboard_shortcuts.open_media": "Media openen",
  "keyboard_shortcuts.pinned": "Jouw vastgemaakte berichten tonen",
  "keyboard_shortcuts.profile": "Gebruikersprofiel auteur openen",
  "keyboard_shortcuts.quote": "Bericht citeren",
  "keyboard_shortcuts.reply": "Reageren",
  "keyboard_shortcuts.requests": "Jouw volgverzoeken tonen",
  "keyboard_shortcuts.search": "Zoekveld focussen",
  "keyboard_shortcuts.spoilers": "Tekst van een inhoudswaarschuwing tonen/verbergen",
  "keyboard_shortcuts.start": "\"Aan de slag\" tonen",
  "keyboard_shortcuts.toggle_hidden": "Inhoudswaarschuwing tonen/verbergen",
  "keyboard_shortcuts.toggle_sensitivity": "Media tonen/verbergen",
  "keyboard_shortcuts.toot": "Nieuw bericht schrijven",
  "keyboard_shortcuts.top": "Naar het begin van de lijst verplaatsen",
  "keyboard_shortcuts.translate": "om een bericht te vertalen",
  "keyboard_shortcuts.unfocus": "Tekst- en zoekveld ontfocussen",
  "keyboard_shortcuts.up": "Naar boven in de lijst bewegen",
  "learn_more_link.got_it": "Begrepen",
  "learn_more_link.learn_more": "Meer informatie",
  "lightbox.close": "Sluiten",
  "lightbox.next": "Volgende",
  "lightbox.previous": "Vorige",
  "lightbox.zoom_in": "Oorspronkelijke grootte weergeven",
  "lightbox.zoom_out": "Passend weergeven",
  "limited_account_hint.action": "Alsnog het profiel tonen",
  "limited_account_hint.title": "Dit profiel is door de moderatoren van {domain} verborgen.",
  "link_preview.author": "Door {name}",
  "link_preview.more_from_author": "Meer van {name}",
  "link_preview.shares": "{count, plural, one {{counter} bericht} other {{counter} berichten}}",
  "lists.add_member": "Toevoegen",
  "lists.add_to_list": "Aan lijst toevoegen",
  "lists.add_to_lists": "{name} aan lijsten toevoegen",
  "lists.create": "Aanmaken",
  "lists.create_a_list_to_organize": "Maak een nieuwe lijst aan om je starttijdlijn te organiseren",
  "lists.create_list": "Lijst aanmaken",
  "lists.delete": "Lijst verwijderen",
  "lists.done": "Klaar",
  "lists.edit": "Lijst bewerken",
  "lists.exclusive": "Leden op je Startpagina verbergen",
  "lists.exclusive_hint": "Als iemand op deze lijst staat, verberg deze persoon dan op je starttijdlijn om te voorkomen dat diens berichten twee keer worden getoond.",
  "lists.find_users_to_add": "Vind gebruikers om toe te voegen",
  "lists.list_members_count": "{count, plural, one{# lid} other{# leden}}",
  "lists.list_name": "Lijstnaam",
  "lists.new_list_name": "Nieuwe lijstnaam",
  "lists.no_lists_yet": "Nog geen lijsten.",
  "lists.no_members_yet": "Nog geen leden.",
  "lists.no_results_found": "Geen resultaten gevonden.",
  "lists.remove_member": "Verwijderen",
  "lists.replies_policy.followed": "Elke gevolgde gebruiker",
  "lists.replies_policy.list": "Leden van de lijst",
  "lists.replies_policy.none": "Niemand",
  "lists.save": "Opslaan",
  "lists.search": "Zoeken",
  "lists.show_replies_to": "Voeg antwoorden van lijstleden toe aan",
  "load_pending": "{count, plural, one {# nieuw item} other {# nieuwe items}}",
  "loading_indicator.label": "Laden…",
  "media_gallery.hide": "Verberg",
  "moved_to_account_banner.text": "Omdat je naar {movedToAccount} bent verhuisd is jouw account {disabledAccount} momenteel uitgeschakeld.",
  "mute_modal.hide_from_notifications": "Onder meldingen verbergen",
  "mute_modal.hide_options": "Opties verbergen",
  "mute_modal.indefinite": "Totdat ik ze niet meer negeer",
  "mute_modal.show_options": "Opties tonen",
  "mute_modal.they_can_mention_and_follow": "De persoon kan jou vermelden en volgen, maar jij ziet niks meer van deze persoon.",
  "mute_modal.they_wont_know": "De persoon krijgt niet te weten dat die wordt genegeerd.",
  "mute_modal.title": "Gebruiker negeren?",
  "mute_modal.you_wont_see_mentions": "Je ziet geen berichten meer die dit account vermelden.",
  "mute_modal.you_wont_see_posts": "De persoon kan nog steeds jouw berichten zien, maar diens berichten zie je niet meer.",
  "navigation_bar.about": "Over",
  "navigation_bar.account_settings": "Wachtwoord en beveiliging",
  "navigation_bar.administration": "Beheer",
  "navigation_bar.advanced_interface": "In geavanceerde webinterface openen",
  "navigation_bar.automated_deletion": "Automatisch berichten verwijderen",
  "navigation_bar.blocks": "Geblokkeerde gebruikers",
  "navigation_bar.bookmarks": "Bladwijzers",
  "navigation_bar.collections": "Verzamelingen",
  "navigation_bar.direct": "Privéberichten",
  "navigation_bar.domain_blocks": "Geblokkeerde servers",
  "navigation_bar.favourites": "Favorieten",
  "navigation_bar.filters": "Filters",
  "navigation_bar.follow_requests": "Volgverzoeken",
  "navigation_bar.followed_tags": "Gevolgde hashtags",
  "navigation_bar.follows_and_followers": "Volgers en gevolgde accounts",
  "navigation_bar.import_export": "Importeren en exporteren",
  "navigation_bar.lists": "Lijsten",
  "navigation_bar.live_feed_local": "Openbare tijdlijn (deze server)",
  "navigation_bar.live_feed_public": "Openbare tijdlijn (alles)",
  "navigation_bar.logout": "Uitloggen",
  "navigation_bar.moderation": "Moderatie",
  "navigation_bar.more": "Meer",
  "navigation_bar.mutes": "Genegeerde gebruikers",
  "navigation_bar.opened_in_classic_interface": "Berichten, accounts en andere specifieke pagina’s, worden standaard geopend in de klassieke webinterface.",
  "navigation_bar.preferences": "Instellingen",
  "navigation_bar.privacy_and_reach": "Privacy en bereik",
  "navigation_bar.search": "Zoeken",
  "navigation_bar.search_trends": "Zoeken / Trends",
  "navigation_panel.collapse_followed_tags": "Menu voor gevolgde hashtags inklappen",
  "navigation_panel.collapse_lists": "Lijstmenu inklappen",
  "navigation_panel.expand_followed_tags": "Menu voor gevolgde hashtags uitklappen",
  "navigation_panel.expand_lists": "Lijstmenu uitklappen",
  "not_signed_in_indicator.not_signed_in": "Je moet inloggen om toegang tot deze informatie te krijgen.",
  "notification.admin.report": "{name} heeft {target} geapporteerd",
  "notification.admin.report_account": "{name} rapporteerde {count, plural, one {een bericht} other {# berichten}} van {target} voor {category}",
  "notification.admin.report_account_other": "{name} rapporteerde {count, plural, one {een bericht} other {# berichten}} van {target}",
  "notification.admin.report_statuses": "{name} rapporteerde {target} voor {category}",
  "notification.admin.report_statuses_other": "{name} rapporteerde {target}",
  "notification.admin.sign_up": "{name} heeft zich geregistreerd",
  "notification.admin.sign_up.name_and_others": "{name} en {count, plural, one {# ander persoon} other {# andere personen}} hebben zich geregistreerd",
  "notification.annual_report.message": "Jouw {year} #Wrapstodon staat klaar! Laat de hoogtepunten en memorabele momenten van jouw jaar zien op Mastodon!",
  "notification.annual_report.view": "#Wrapstodon bekijken",
  "notification.favourite": "{name} markeerde jouw bericht als favoriet",
  "notification.favourite.name_and_others_with_link": "{name} en <a>{count, plural, one {# ander persoon} other {# andere personen}}</a> hebben jouw bericht als favoriet gemarkeerd",
  "notification.favourite_pm": "{name} heeft je privébericht als favoriet gemarkeerd",
  "notification.favourite_pm.name_and_others_with_link": "{name} en <a>{count, plural, one {# ander} other {# anderen}}</a> hebben je privébericht als favoriet gemarkeerd",
  "notification.follow": "{name} volgt jou nu",
  "notification.follow.name_and_others": "{name} en <a>{count, plural, one {# ander persoon} other {# andere personen}}</a> volgen jou nu",
  "notification.follow_request": "{name} wil jou graag volgen",
  "notification.follow_request.name_and_others": "{name} en {count, plural, one {# ander persoon} other {# andere personen}} hebben gevraagd om je te volgen",
  "notification.label.mention": "Vermelding",
  "notification.label.private_mention": "Privébericht",
  "notification.label.private_reply": "Privéreactie",
  "notification.label.quote": "{name} heeft jouw bericht geciteerd",
  "notification.label.reply": "Reactie",
  "notification.mention": "Vermelding",
  "notification.mentioned_you": "Je bent vermeld door {name}",
  "notification.moderation-warning.learn_more": "Meer informatie",
  "notification.moderation_warning": "Je hebt een moderatie-waarschuwing ontvangen",
  "notification.moderation_warning.action_delete_statuses": "Sommige van je berichten zijn verwijderd.",
  "notification.moderation_warning.action_disable": "Jouw account is uitgeschakeld.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Sommige van je berichten zijn gemarkeerd als gevoelig.",
  "notification.moderation_warning.action_none": "Jouw account heeft een moderatie-waarschuwing ontvangen.",
  "notification.moderation_warning.action_sensitive": "Je berichten worden vanaf nu als gevoelig gemarkeerd.",
  "notification.moderation_warning.action_silence": "Jouw account is beperkt.",
  "notification.moderation_warning.action_suspend": "Jouw account is opgeschort.",
  "notification.own_poll": "Jouw peiling is beëindigd",
  "notification.poll": "Een peiling waaraan jij hebt meegedaan is beëindigd",
  "notification.quoted_update": "{name} bewerkte een door jou geciteerd bericht",
  "notification.reblog": "{name} boostte jouw bericht",
  "notification.reblog.name_and_others_with_link": "{name} en <a>{count, plural, one {# ander persoon} other {# andere personen}}</a> hebben jouw bericht geboost",
  "notification.relationships_severance_event": "Verloren verbindingen met {name}",
  "notification.relationships_severance_event.account_suspension": "Een beheerder van {from} heeft {target} geschorst, wat betekent dat je geen updates meer van hen kunt ontvangen of met hen kunt communiceren.",
  "notification.relationships_severance_event.domain_block": "Een beheerder van {from} heeft {target} geblokkeerd, inclusief {followersCount} van jouw volgers en {followingCount, plural, one {# account} other {# accounts}} die je volgt.",
  "notification.relationships_severance_event.learn_more": "Meer informatie",
  "notification.relationships_severance_event.user_domain_block": "Je hebt {target} geblokkeerd, waarmee je {followersCount} van je volgers en {followingCount, plural, one {# account} other {# accounts}} die je volgt, bent verloren.",
  "notification.status": "{name} heeft zojuist een bericht geplaatst",
  "notification.update": "{name} bewerkte een bericht",
  "notification_requests.accept": "Accepteren",
  "notification_requests.accept_multiple": "{count, plural, one {# verzoek accepteren…} other {# verzoeken accepteren…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, one {Verzoek accepteren} other {Verzoeken accepteren}}",
  "notification_requests.confirm_accept_multiple.message": "Je staat op het punt om {count, plural, one {een meldingsverzoek} other {# meldingsverzoeken}} te accepteren. Weet je zeker dat je door wilt gaan?",
  "notification_requests.confirm_accept_multiple.title": "Meldingsverzoeken accepteren?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, one {Verzoek afwijzen} other {Verzoeken afwijzen}}",
  "notification_requests.confirm_dismiss_multiple.message": "Je staat op het punt om {count, plural, one {een meldingsverzoek} other {# meldingsverzoeken}} af te wijzen. Je zult niet in staat zijn om {count, plural, one {hier} other {hier}} weer gemakkelijk toegang toe te krijgen. Wil je doorgaan?",
  "notification_requests.confirm_dismiss_multiple.title": "Meldingsverzoeken afwijzen?",
  "notification_requests.dismiss": "Afwijzen",
  "notification_requests.dismiss_multiple": "{count, plural, one {# verzoek afwijzen…} other {# verzoeken afwijzen…}}",
  "notification_requests.edit_selection": "Bewerken",
  "notification_requests.exit_selection": "Klaar",
  "notification_requests.explainer_for_limited_account": "Meldingen van dit account zijn gefilterd omdat dit account door een moderator is beperkt.",
  "notification_requests.explainer_for_limited_remote_account": "Meldingen van dit account zijn gefilterd omdat dit account of diens server door een moderator is beperkt.",
  "notification_requests.maximize": "Maximaliseren",
  "notification_requests.minimize_banner": "Banner met gefilterde meldingen minimaliseren",
  "notification_requests.notifications_from": "Meldingen van {name}",
  "notification_requests.title": "Gefilterde meldingen",
  "notification_requests.view": "Meldingen bekijken",
  "notifications.clear": "Meldingen verwijderen",
  "notifications.clear_confirmation": "Weet je het zeker dat je al jouw meldingen wilt verwijderen?",
  "notifications.clear_title": "Meldingen verwijderen?",
  "notifications.column_settings.admin.report": "Nieuwe rapportages:",
  "notifications.column_settings.admin.sign_up": "Nieuwe registraties:",
  "notifications.column_settings.alert": "Desktopmeldingen",
  "notifications.column_settings.favourite": "Favorieten:",
  "notifications.column_settings.filter_bar.advanced": "Alle categorieën tonen",
  "notifications.column_settings.filter_bar.category": "Snelle filterbalk",
  "notifications.column_settings.follow": "Nieuwe volgers:",
  "notifications.column_settings.follow_request": "Nieuw volgverzoek:",
  "notifications.column_settings.group": "Groeperen",
  "notifications.column_settings.mention": "Vermeldingen:",
  "notifications.column_settings.poll": "Peilingresultaten:",
  "notifications.column_settings.push": "Pushmeldingen",
  "notifications.column_settings.quote": "Citaten:",
  "notifications.column_settings.reblog": "Boosts:",
  "notifications.column_settings.show": "In kolom tonen",
  "notifications.column_settings.sound": "Geluid afspelen",
  "notifications.column_settings.status": "Nieuwe berichten:",
  "notifications.column_settings.unread_notifications.category": "Ongelezen meldingen",
  "notifications.column_settings.unread_notifications.highlight": "Ongelezen meldingen markeren",
  "notifications.column_settings.update": "Bewerkingen:",
  "notifications.filter.all": "Alles",
  "notifications.filter.boosts": "Boosts",
  "notifications.filter.favourites": "Favorieten",
  "notifications.filter.follows": "Nieuwe volgers",
  "notifications.filter.mentions": "Vermeldingen",
  "notifications.filter.polls": "Peilingresultaten",
  "notifications.filter.statuses": "Berichten van geobserveerde accounts",
  "notifications.grant_permission": "Toestemming geven.",
  "notifications.group": "{count} meldingen",
  "notifications.mark_as_read": "Markeer elke melding als gelezen",
  "notifications.permission_denied": "Desktopmeldingen zijn niet beschikbaar omdat een eerdere browsertoestemming werd geweigerd",
  "notifications.permission_denied_alert": "Desktopmeldingen kunnen niet worden ingeschakeld, omdat een eerdere browsertoestemming werd geweigerd",
  "notifications.permission_required": "Desktopmeldingen zijn niet beschikbaar omdat de benodigde toestemming niet is verleend.",
  "notifications.policy.accept": "Accepteren",
  "notifications.policy.accept_hint": "In meldingen weergeven",
  "notifications.policy.drop": "Negeren",
  "notifications.policy.drop_hint": "Permanent verwijderen",
  "notifications.policy.filter": "Filter",
  "notifications.policy.filter_hint": "Naar gefilterde inbox voor meldingen verzenden",
  "notifications.policy.filter_limited_accounts_hint": "Beperkt door servermoderatoren",
  "notifications.policy.filter_limited_accounts_title": "Gemodereerde accounts",
  "notifications.policy.filter_new_accounts.hint": "In de afgelopen {days, plural, one {24 uur} other {# dagen}} geregistreerd",
  "notifications.policy.filter_new_accounts_title": "Nieuwe accounts",
  "notifications.policy.filter_not_followers_hint": "Inclusief mensen die jou korter dan {days, plural, one {24 uur} other {# dagen}} volgen",
  "notifications.policy.filter_not_followers_title": "Mensen die jou niet volgen",
  "notifications.policy.filter_not_following_hint": "Totdat je ze handmatig goedkeurt",
  "notifications.policy.filter_not_following_title": "Mensen die jij niet volgt",
  "notifications.policy.filter_private_mentions_hint": "Onzichtbaar tenzij het een antwoord is op een privébericht van jou of wanneer je de afzender volgt",
  "notifications.policy.filter_private_mentions_title": "Ongevraagde privéberichten",
  "notifications.policy.title": "Meldingen beheren van…",
  "notifications_permission_banner.enable": "Desktopmeldingen inschakelen",
  "notifications_permission_banner.how_to_control": "Om meldingen te ontvangen wanneer Mastodon niet open staat. Je kunt precies bepalen welke soort interacties wel of geen desktopmeldingen geven via de bovenstaande {icon} knop.",
  "notifications_permission_banner.title": "Mis nooit meer iets",
  "onboarding.follows.back": "Terug",
  "onboarding.follows.empty": "Helaas kunnen op dit moment geen resultaten worden getoond. Je kunt proberen te zoeken of op de verkenningspagina te bladeren om mensen te vinden die je kunt volgen, of probeer het later opnieuw.",
  "onboarding.follows.next": "Volgende: je profiel instellen",
  "onboarding.follows.search": "Zoeken",
  "onboarding.follows.title": "Volg mensen om te beginnen",
  "onboarding.profile.discoverable": "Maak mijn profiel vindbaar",
  "onboarding.profile.discoverable_hint": "Wanneer je akkoord gaat met het vindbaar zijn op Mastodon, verschijnen je berichten in zoekresultaten en kunnen ze trending worden, en je profiel kan aan andere mensen worden aanbevolen wanneer ze vergelijkbare interesses hebben.",
  "onboarding.profile.display_name": "Weergavenaam",
  "onboarding.profile.display_name_hint": "Jouw volledige naam of een leuke bijnaam…",
  "onboarding.profile.finish": "Voltooien",
  "onboarding.profile.note": "Biografie",
  "onboarding.profile.note_hint": "Je kunt andere mensen @vermelden of #hashtags gebruiken…",
  "onboarding.profile.title": "Profiel instellen",
  "onboarding.profile.upload_avatar": "Profielfoto uploaden",
  "onboarding.profile.upload_header": "Omslagfoto voor het profiel uploaden",
  "password_confirmation.exceeds_maxlength": "Wachtwoordbevestiging overschrijdt de maximale wachtwoordlengte",
  "password_confirmation.mismatching": "Wachtwoordbevestiging komt niet overeen",
  "picture_in_picture.restore": "Terugzetten",
  "poll.closed": "Gesloten",
  "poll.refresh": "Vernieuwen",
  "poll.reveal": "Resultaten bekijken",
  "poll.total_people": "{count, plural, one {# persoon} other {# mensen}}",
  "poll.total_votes": "{count, plural, one {# stem} other {# stemmen}}",
  "poll.vote": "Stemmen",
  "poll.voted": "Je hebt hier op gestemd",
  "poll.votes": "{votes, plural, one {# stem} other {# stemmen}}",
  "poll_button.add_poll": "Peiling toevoegen",
  "poll_button.remove_poll": "Peiling verwijderen",
  "privacy.change": "Privacy van dit bericht aanpassen",
  "privacy.direct.long": "Alleen voor mensen die specifiek in het bericht worden vermeld",
  "privacy.direct.short": "Privébericht",
  "privacy.private.long": "Alleen jouw volgers",
  "privacy.private.short": "Volgers",
  "privacy.public.long": "Iedereen op Mastodon en daarbuiten",
  "privacy.public.short": "Openbaar",
  "privacy.quote.anyone": "{visibility}, citeren toegestaan",
  "privacy.quote.disabled": "{visibility}, citeren uitgeschakeld",
  "privacy.quote.limited": "{visibility}, citeren beperkt",
  "privacy.unlisted.additional": "Dit is vergelijkbaar met openbaar, behalve dat het bericht niet op openbare tijdlijnen, onder hashtags, verkennen of zoeken verschijnt, zelfs als je je account daarvoor hebt ingesteld.",
  "privacy.unlisted.long": "Niet zichtbaar in de zoekresultaten van Mastodon, onder trends, hashtags en op openbare tijdlijnen",
  "privacy.unlisted.short": "Minder openbaar",
  "privacy_policy.last_updated": "Laatst bijgewerkt op {date}",
  "privacy_policy.title": "Privacybeleid",
  "quote_error.edit": "Citaten kunnen niet tijdens het bewerken van een bericht worden toegevoegd.",
  "quote_error.poll": "Het is niet mogelijk om polls te citeren.",
  "quote_error.private_mentions": "Citaten in privéberichten zijn niet toegestaan.",
  "quote_error.quote": "Je kunt maar één bericht per keer citeren.",
  "quote_error.unauthorized": "Je bent niet gemachtigd om dit bericht te citeren.",
  "quote_error.upload": "Je kunt geen mediabijlage aan een bericht met een citaat toevoegen.",
  "recommended": "Aanbevolen",
  "refresh": "Vernieuwen",
  "regeneration_indicator.please_stand_by": "Even geduld alsjeblieft.",
  "regeneration_indicator.preparing_your_home_feed": "Voorbereiden van jouw starttijdlijn…",
  "relative_time.days": "{number}d",
  "relative_time.full.days": "{number, plural, one {# dag} other {# dagen}} geleden",
  "relative_time.full.hours": "{number, plural, one {# uur} other {# uur}} geleden",
  "relative_time.full.just_now": "zojuist",
  "relative_time.full.minutes": "{number, plural, one {# minuut} other {# minuten}} geleden",
  "relative_time.full.seconds": "{number, plural, one {# seconde} other {# seconden}} geleden",
  "relative_time.hours": "{number}u",
  "relative_time.just_now": "nu",
  "relative_time.minutes": "{number}m",
  "relative_time.seconds": "{number}s",
  "relative_time.today": "vandaag",
  "remove_quote_hint.button_label": "Begrepen",
  "remove_quote_hint.message": "Je kunt dit doen vanuit het {icon} optiesmenu.",
  "remove_quote_hint.title": "Wil je jouw geciteerd bericht verwijderen?",
  "reply_indicator.attachments": "{count, plural, one {# bijlage} other {# bijlagen}}",
  "reply_indicator.cancel": "Annuleren",
  "reply_indicator.poll": "Peiling",
  "report.block": "Blokkeren",
  "report.block_explanation": "Je kunt diens berichten niet zien. Je kunt door diegene niet gevolgd worden en jouw berichten zijn onzichtbaar. Diegene kan zien dat die door jou is geblokkeerd.",
  "report.categories.legal": "Juridisch",
  "report.categories.other": "Overig",
  "report.categories.spam": "Spam",
  "report.categories.violation": "De inhoud overtreedt een of meerdere serverregels",
  "report.category.subtitle": "Kies wat het beste overeenkomt",
  "report.category.title": "Vertel ons wat er met dit {type} aan de hand is",
  "report.category.title_account": "account",
  "report.category.title_status": "bericht",
  "report.close": "Klaar",
  "report.collection_comment": "Waarom wil je deze verzameling rapporteren?",
  "report.comment.title": "Zijn er nog andere dingen waarvan je denkt dat wij dat moeten weten?",
  "report.forward": "Naar {target} doorsturen",
  "report.forward_hint": "Het account bevindt zich op een andere server. Wil je daar eveneens een geanonimiseerde kopie van deze rapportage naar toe sturen?",
  "report.mute": "Negeren",
  "report.mute_explanation": "Je kunt diens berichten niet zien. Je kunt nog wel gevolgd worden en jouw berichten zijn nog zichtbaar, maar diegene kan niet zien dat die wordt genegeerd.",
  "report.next": "Volgende",
  "report.placeholder": "Extra opmerkingen",
  "report.reasons.dislike": "Ik vind het niet leuk",
  "report.reasons.dislike_description": "Het is iets wat je niet wilt zien",
  "report.reasons.legal": "Het is wettelijk niet toegestaan",
  "report.reasons.legal_description": "Je meent dat het de wet van jouw land of dat van de serverlocatie schendt",
  "report.reasons.other": "Het is iets anders",
  "report.reasons.other_description": "Het probleem past niet in een andere categorie",
  "report.reasons.spam": "Het is spam",
  "report.reasons.spam_description": "Schadelijke links, reclame, misleiding of herhalende antwoorden",
  "report.reasons.violation": "Het schendt de serverregels",
  "report.reasons.violation_description": "Je weet dat het specifieke regels schendt",
  "report.rules.subtitle": "Selecteer wat van toepassing is",
  "report.rules.title": "Welke regels worden geschonden?",
  "report.statuses.subtitle": "Selecteer wat van toepassing is",
  "report.statuses.title": "Zijn er berichten die deze rapportage ondersteunen?",
  "report.submission_error": "Deze rapportage kon niet worden ingediend",
  "report.submission_error_details": "Controleer de netwerkverbinding en probeer het later opnieuw.",
  "report.submit": "Verzenden",
  "report.target": "{target} rapporteren",
  "report.thanks.take_action": "Hier zijn jouw opties waarmee je kunt bepalen wat je in Mastodon wilt zien:",
  "report.thanks.take_action_actionable": "Terwijl wij jouw rapportage beoordelen, kun je deze maatregelen tegen @{name} nemen:",
  "report.thanks.title": "Wil je dit niet zien?",
  "report.thanks.title_actionable": "Dank je voor het rapporteren. Wij gaan er naar kijken.",
  "report.unfollow": "@{name} ontvolgen",
  "report.unfollow_explanation": "Je volgt dit account. Om diens berichten niet meer op jouw starttijdlijn te zien, kun je diegene ontvolgen.",
  "report_notification.attached_statuses": "{count, plural, one {{count} bericht} other {{count} berichten}} toegevoegd",
  "report_notification.categories.legal": "Juridisch",
  "report_notification.categories.legal_sentence": "illegale inhoud",
  "report_notification.categories.other": "Overig",
  "report_notification.categories.other_sentence": "overig",
  "report_notification.categories.spam": "Spam",
  "report_notification.categories.spam_sentence": "spam",
  "report_notification.categories.violation": "Overtreden regel(s)",
  "report_notification.categories.violation_sentence": "serverregel overtreden",
  "report_notification.open": "Rapportage openen",
  "search.clear": "Zoekopdracht wissen",
  "search.no_recent_searches": "Geen recente zoekopdrachten",
  "search.placeholder": "Zoeken",
  "search.quick_action.account_search": "Accounts die overeenkomen met {x}",
  "search.quick_action.go_to_account": "Ga naar account {x}",
  "search.quick_action.go_to_hashtag": "Ga naar hashtag {x}",
  "search.quick_action.open_url": "URL in Mastodon openen",
  "search.quick_action.status_search": "Berichten die overeenkomen met {x}",
  "search.search_or_paste": "Zoeken of een URL plakken",
  "search_popout.full_text_search_disabled_message": "Niet beschikbaar op {domain}.",
  "search_popout.full_text_search_logged_out_message": "Alleen beschikbaar als je bent ingelogd.",
  "search_popout.language_code": "ISO-taalcode",
  "search_popout.options": "Zoekopties",
  "search_popout.quick_actions": "Snelle acties",
  "search_popout.recent": "Recente zoekopdrachten",
  "search_popout.specific_date": "specifieke datum",
  "search_popout.user": "gebruiker",
  "search_results.accounts": "Accounts",
  "search_results.all": "Alles",
  "search_results.hashtags": "Hashtags",
  "search_results.no_results": "Geen resultaten.",
  "search_results.no_search_yet": "Probeer te zoeken naar berichten, profielen of hashtags.",
  "search_results.see_all": "Alles bekijken",
  "search_results.statuses": "Berichten",
  "search_results.title": "Naar \"{q}\" zoeken",
  "server_banner.about_active_users": "Aantal gebruikers tijdens de afgelopen 30 dagen (MAU)",
  "server_banner.active_users": "actieve gebruikers",
  "server_banner.administered_by": "Beheerd door:",
  "server_banner.is_one_of_many": "{domain} is een van de vele onafhankelijke Mastodon-servers die je kunt gebruiken om deel te nemen aan de fediverse.",
  "server_banner.server_stats": "Serverstats:",
  "sign_in_banner.create_account": "Registreren",
  "sign_in_banner.follow_anyone": "Volg iedereen in de fediverse en zie het allemaal in chronologische volgorde. Geen algoritmes, advertenties of clickbaits.",
  "sign_in_banner.mastodon_is": "Mastodon is de beste manier om wat er gebeurt bij te houden.",
  "sign_in_banner.sign_in": "Inloggen",
  "sign_in_banner.sso_redirect": "Inloggen of Registreren",
  "skip_links.hotkey": "<span>Sneltoets</span> {hotkey}",
  "skip_links.skip_to_content": "Ga naar de hoofdinhoud",
  "skip_links.skip_to_navigation": "Ga naar de hoofdnavigatie",
  "status.admin_account": "Moderatie-omgeving van @{name} openen",
  "status.admin_domain": "Moderatie-omgeving van {domain} openen",
  "status.admin_status": "Dit bericht in de moderatie-omgeving tonen",
  "status.all_disabled": "Boosts en citaten zijn uitgeschakeld",
  "status.block": "@{name} blokkeren",
  "status.bookmark": "Bladwijzer toevoegen",
  "status.cancel_reblog_private": "Niet langer boosten",
  "status.cannot_quote": "Je bent niet gemachtigd om dit bericht te citeren",
  "status.cannot_reblog": "Dit bericht kan niet geboost worden",
  "status.contains_quote": "Bevat citaat",
  "status.context.loading": "Meer reacties laden",
  "status.context.loading_error": "Kon geen nieuwe reacties laden",
  "status.context.loading_success": "Nieuwe reacties geladen",
  "status.context.more_replies_found": "Meer reacties gevonden",
  "status.context.retry": "Opnieuw proberen",
  "status.context.show": "Tonen",
  "status.continued_thread": "Vervolg van gesprek",
  "status.copy": "Link naar bericht kopiëren",
  "status.delete": "Verwijderen",
  "status.delete.success": "Bericht verwijderd",
  "status.detailed_status": "Uitgebreide gespreksweergave",
  "status.direct": "@{name} een privébericht sturen",
  "status.direct_indicator": "Privébericht",
  "status.edit": "Bewerken",
  "status.edited": "Laatste bewerking op {date}",
  "status.edited_x_times": "{count, plural, one {{count} keer} other {{count} keer}} bewerkt",
  "status.embed": "Embed-code verkrijgen",
  "status.favourite": "Favoriet",
  "status.favourites_count": "{count, plural, one {{counter} favoriet} other {{counter} favorieten}}",
  "status.filter": "Dit bericht filteren",
  "status.history.created": "{name} plaatste dit {date}",
  "status.history.edited": "{name} bewerkte dit {date}",
  "status.load_more": "Meer laden",
  "status.media.open": "Klik om te openen",
  "status.media.show": "Klik om te tonen",
  "status.media_hidden": "Media verborgen",
  "status.mention": "@{name} vermelden",
  "status.more": "Meer",
  "status.mute": "@{name} negeren",
  "status.mute_conversation": "Gesprek negeren",
  "status.open": "Volledig bericht tonen",
  "status.pin": "Aan profielpagina vastmaken",
  "status.quote": "Citeren",
  "status.quote.cancel": "Citeren annuleren",
  "status.quote_error.blocked_account_hint.title": "Dit bericht is verborgen, omdat jij @{name} hebt geblokkeerd.",
  "status.quote_error.blocked_domain_hint.title": "Dit bericht is verborgen, omdat jij alles van {domain} hebt geblokkeerd.",
  "status.quote_error.filtered": "Verborgen door een van je filters",
  "status.quote_error.limited_account_hint.action": "Alsnog tonen",
  "status.quote_error.limited_account_hint.title": "Dit account is door de moderatoren van {domain} verborgen.",
  "status.quote_error.muted_account_hint.title": "Dit bericht is verborgen, omdat jij @{name} hebt genegeerd.",
  "status.quote_error.not_available": "Bericht niet beschikbaar",
  "status.quote_error.pending_approval": "Bericht in afwachting van goedkeuring",
  "status.quote_error.pending_approval_popout.body": "Op Mastodon kun je bepalen of iemand je mag citeren. Dit bericht is in afwachting van de goedkeuring van de oorspronkelijke auteur.",
  "status.quote_error.revoked": "Bericht verwijderd door auteur",
  "status.quote_followers_only": "Alleen volgers mogen dit bericht citeren",
  "status.quote_manual_review": "De auteur gaat het handmatig beoordelen",
  "status.quote_noun": "Citaat",
  "status.quote_policy_change": "Wijzig wie jou mag citeren",
  "status.quote_post_author": "Citeerde een bericht van @{name}",
  "status.quote_private": "Citeren van berichten aan alleen volgers is niet mogelijk",
  "status.quotes.empty": "Niemand heeft dit bericht nog geciteerd. Wanneer iemand dat doet, wordt dat hier getoond.",
  "status.quotes.local_other_disclaimer": "Citaten afgewezen door de auteur worden niet getoond.",
  "status.quotes.remote_other_disclaimer": "Alleen citaten van {domain} worden hier gegarandeerd weergegeven. Citaten afgewezen door de auteur worden niet getoond.",
  "status.quotes_count": "{count, plural, one {{counter} citaat} other {{counter} citaten}}",
  "status.read_more": "Meer lezen",
  "status.reblog": "Boosten",
  "status.reblog_or_quote": "Boosten of citeren",
  "status.reblog_private": "Opnieuw met je volgers delen",
  "status.reblogged_by": "{name} boostte",
  "status.reblogs.empty": "Niemand heeft dit bericht nog geboost. Wanneer iemand dit doet, valt dat hier te zien.",
  "status.reblogs_count": "{count, plural, one {{counter} boost} other {{counter} boosts}}",
  "status.redraft": "Verwijderen en herschrijven",
  "status.remove_bookmark": "Bladwijzer verwijderen",
  "status.remove_favourite": "Verwijderen uit favorieten",
  "status.remove_quote": "Verwijderen",
  "status.replied_in_thread": "Reageerde in gesprek",
  "status.replied_to": "Reageerde op {name}",
  "status.reply": "Reageren",
  "status.replyAll": "Op iedereen reageren",
  "status.report": "@{name} rapporteren",
  "status.request_quote": "Verzoek om te citeren",
  "status.revoke_quote": "Mijn bericht uit het bericht van @{name} verwijderen",
  "status.sensitive_warning": "Gevoelige inhoud",
  "status.share": "Delen",
  "status.show_less_all": "Alles minder tonen",
  "status.show_more_all": "Alles meer tonen",
  "status.show_original": "Origineel bekijken",
  "status.title.with_attachments": "{user} heeft {attachmentCount, plural, one {een bijlage} other {{attachmentCount} bijlagen}} toegevoegd",
  "status.translate": "Vertalen",
  "status.translated_from_with": "Vertaald vanuit het {lang} met behulp van {provider}",
  "status.uncached_media_warning": "Voorvertoning niet beschikbaar",
  "status.unmute_conversation": "Gesprek niet langer negeren",
  "status.unpin": "Van profielpagina losmaken",
  "subscribed_languages.lead": "Na de wijziging worden alleen berichten van geselecteerde talen op jouw starttijdlijn en in lijsten weergegeven.",
  "subscribed_languages.save": "Wijzigingen opslaan",
  "subscribed_languages.target": "Getoonde talen voor {target} wijzigen",
  "tabs_bar.home": "Start",
  "tabs_bar.menu": "Menu",
  "tabs_bar.notifications": "Meldingen",
  "tabs_bar.publish": "Nieuw bericht",
  "tabs_bar.search": "Zoeken",
  "tag.remove": "Verwijderen",
  "terms_of_service.effective_as_of": "Van kracht met ingang van {date}",
  "terms_of_service.title": "Gebruiksvoorwaarden",
  "terms_of_service.upcoming_changes_on": "Aankomende wijzigingen op {date}",
  "time_remaining.days": "{number, plural, one {# dag} other {# dagen}} te gaan",
  "time_remaining.hours": "{number, plural, one {# uur} other {# uur}} te gaan",
  "time_remaining.minutes": "{number, plural, one {# minuut} other {# minuten}} te gaan",
  "time_remaining.moments": "Nog enkele ogenblikken resterend",
  "time_remaining.seconds": "{number, plural, one {# seconde} other {# seconden}} te gaan",
  "trends.counter_by_accounts": "{count, plural, one {{counter} persoon} other {{counter} mensen}} {days, plural, one {in het afgelopen etmaal} other {in de afgelopen {days} dagen}}",
  "trends.trending_now": "Huidige trends",
  "ui.beforeunload": "Je concept gaat verloren wanneer je Mastodon verlaat.",
  "units.short.billion": "{count} mrd.",
  "units.short.million": "{count} mln.",
  "units.short.thousand": "{count}k",
  "upload_area.title": "Hiernaar toe slepen om te uploaden",
  "upload_button.label": "Afbeeldingen, een video- of een geluidsbestand toevoegen",
  "upload_error.limit": "Uploadlimiet van bestand overschreden.",
  "upload_error.poll": "Het uploaden van bestanden is bij peilingen niet toegestaan.",
  "upload_error.quote": "Je kunt geen bestand aan een bericht met een citaat toevoegen.",
  "upload_form.drag_and_drop.instructions": "Druk op spatie of enter om een mediabijlage op te pakken. Gebruik de pijltjestoetsen om de bijlage in een bepaalde richting te verplaatsen. Druk opnieuw op de spatiebalk of enter om de mediabijlage op de nieuwe positie te plaatsen, of druk op escape om te annuleren.",
  "upload_form.drag_and_drop.on_drag_cancel": "Slepen is geannuleerd. Mediabijlage {item} is niet verplaatst.",
  "upload_form.drag_and_drop.on_drag_end": "Mediabijlage {item} is niet verplaatst.",
  "upload_form.drag_and_drop.on_drag_over": "Mediabijlage {item} is verplaatst.",
  "upload_form.drag_and_drop.on_drag_start": "Mediabijlage {item} is opgepakt.",
  "upload_form.edit": "Bewerken",
  "upload_progress.label": "Uploaden...",
  "upload_progress.processing": "Bezig…",
  "username.taken": "Die gebruikersnaam is al in gebruik. Probeer een andere",
  "video.close": "Video sluiten",
  "video.download": "Bestand downloaden",
  "video.exit_fullscreen": "Volledig scherm sluiten",
  "video.expand": "Video groter maken",
  "video.fullscreen": "Volledig scherm",
  "video.hide": "Video verbergen",
  "video.mute": "Dempen",
  "video.pause": "Pauze",
  "video.play": "Afspelen",
  "video.skip_backward": "Terugspoelen",
  "video.skip_forward": "Vooruitspoelen",
  "video.unmute": "Dempen opheffen",
  "video.volume_down": "Volume omlaag",
  "video.volume_up": "Volume omhoog",
  "visibility_modal.button_title": "Privacy instellen",
  "visibility_modal.direct_quote_warning.text": "Wanneer je de huidige instellingen opslaat wordt het citaat in een link veranderd.",
  "visibility_modal.direct_quote_warning.title": "Privéberichten kunnen geen citaten bevatten",
  "visibility_modal.header": "Zichtbaarheid en interactie",
  "visibility_modal.helper.direct_quoting": "Privéberichten afkomstig van Mastodon kunnen niet door anderen worden geciteerd.",
  "visibility_modal.helper.privacy_editing": "De zichtbaarheid kan niet meer worden gewijzigd nadat een bericht is gepubliceerd.",
  "visibility_modal.helper.privacy_private_self_quote": "Jouw eigen citaten van berichten aan alleen volgers kunnen niet openbaar worden gemaakt.",
  "visibility_modal.helper.private_quoting": "Berichten aan alleen volgers afkomstig van Mastodon kunnen niet door anderen worden geciteerd.",
  "visibility_modal.helper.unlisted_quoting": "Wanneer mensen jou citeren, verschijnt hun bericht ook niet onder trends.",
  "visibility_modal.instructions": "Bepaal wie wat met dit bericht mag doen. Je kunt ook de instellingen voor alle toekomstige berichten aanpassen door naar <link>Voorkeuren > Standaardinstellingen voor berichten</link> te gaan.",
  "visibility_modal.privacy_label": "Zichtbaarheid",
  "visibility_modal.quote_followers": "Alleen volgers",
  "visibility_modal.quote_label": "Wie mag jou citeren",
  "visibility_modal.quote_nobody": "Alleen ik",
  "visibility_modal.quote_public": "Iedereen",
  "visibility_modal.save": "Opslaan"
}
